import * as React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

export const SvgIcon = styled.svg`
  margin-top: -0.105em;
  margin-bottom: -0.145em;
  height: 1.25em;
  width: 1.25em;
  vertical-align: -0.185em;
`

export function Add() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </SvgIcon>
  )
}

export function ArrowRightAlt() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9784 5.0429C13.3689 4.65237 14.0021 4.65237 14.3926 5.04289L20.7152 11.3654C20.9028 11.553 21.0081 11.8073 21.0081 12.0725C21.0081 12.3378 20.9028 12.5921 20.7152 12.7797L14.3926 19.1023C14.0021 19.4928 13.3689 19.4928 12.9784 19.1023C12.5879 18.7117 12.5879 18.0786 12.9784 17.688L17.5939 13.0725H3.75C3.19772 13.0725 2.75 12.6248 2.75 12.0725C2.75 11.5203 3.19772 11.0725 3.75 11.0725H17.5939L12.9784 6.45711C12.5879 6.06659 12.5879 5.43342 12.9784 5.0429Z"
        fill="#CDCED0"
      />
    </SvgIcon>
  )
}

export function BankNote() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M2,5v14h20V5H2z M9,17l-5-5V7h11l5,5v5H9z" />
      <circle fill="currentColor" cx="12" cy="12" r="3" />
    </SvgIcon>
  )
}

export function CoinStack() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4.086,5C4.562,4.595,6.216,4,8,4s3.438,0.595,3.914,1H14c0-2.243-4.121-3-6-3S2,2.757,2,5v12c0,2.245,4.121,3,6,3c0.287,0,0.631-0.021,1-0.058v-2.009C8.675,17.974,8.342,18,8,18c-1.916,0-3.682-0.684-4-1.086v-0.693C5.32,16.776,6.985,17,8,17c0.288,0,0.631-0.021,1-0.058v-2.009C8.675,14.974,8.342,15,8,15c-1.937,0-3.709-0.697-4-1.098v-0.682C5.32,13.776,6.985,14,8,14c0.288,0,0.631-0.021,1-0.058v-2.009C8.675,11.974,8.342,12,8,12c-1.937,0-3.709-0.697-4-1.098v-0.682C5.32,10.776,6.985,11,8,11c0.288,0,0.631-0.021,1-0.058V8.934C8.675,8.974,8.342,9,8,9C6.063,9,4.291,8.303,4,7.902V7.221C5.32,7.776,6.985,8,8,8c0.288,0,0.631-0.021,1-0.058V5.935C8.675,5.974,8.342,6,8,6C6.216,6,4.562,5.407,4.086,5z"
      />
      <path
        fill="currentColor"
        d="M16,7c-1.879,0-6,0.757-6,3v9c0,2.245,4.121,3,6,3s6-0.755,6-3v-9C22,7.757,17.879,7,16,7z M20,12.902C19.709,13.303,17.937,14,16,14s-3.709-0.697-4-1.098v-0.682C13.32,12.776,14.985,13,16,13s2.68-0.224,4-0.779V12.902z M20,15.902C19.709,16.303,17.937,17,16,17s-3.709-0.697-4-1.098v-0.682C13.32,15.776,14.985,16,16,16s2.68-0.224,4-0.779V15.902z M16,9c1.784,0,3.438,0.595,3.914,1c-0.476,0.407-2.13,1-3.914,1s-3.438-0.593-3.914-1C12.562,9.595,14.216,9,16,9z M16,20c-1.916,0-3.682-0.684-4-1.086v-0.693C13.32,18.776,14.985,19,16,19s2.68-0.224,4-0.779v0.693C19.682,19.316,17.916,20,16,20z"
      />
    </SvgIcon>
  )
}

export function Chat() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
      />
    </SvgIcon>
  )
}

export function Check() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
      />
    </SvgIcon>
  )
}

export function CheckBold() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </SvgIcon>
  )
}

export function CheckCircle() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      />
    </SvgIcon>
  )
}

export function Clear() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M6.00195 22L22.0018 6.00013"
        stroke="#5A5959"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M6.00195 6L22.0018 21.9999"
        stroke="#5A5959"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}

export function Edit() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      />
    </SvgIcon>
  )
}

export function Email() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Error() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      />
    </SvgIcon>
  )
}

export function Visibility() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.875 4C8.81571 4 6.5928 5.2088 5.13945 6.71805C3.71592 8.19633 3 9.99942 3 11.25C3 12.5006 3.71592 14.3037 5.13945 15.7819C6.5928 17.2912 8.81571 18.5 11.875 18.5C14.9343 18.5 17.1572 17.2912 18.6106 15.7819C20.0341 14.3037 20.75 12.5006 20.75 11.25C20.75 9.99942 20.0341 8.19633 18.6106 6.71805C17.1572 5.2088 14.9343 4 11.875 4ZM11.875 9.8125C11.0811 9.8125 10.4375 10.4561 10.4375 11.25C10.4375 12.0439 11.0811 12.6875 11.875 12.6875C12.6689 12.6875 13.3125 12.0439 13.3125 11.25C13.3125 10.4561 12.6689 9.8125 11.875 9.8125ZM8.4375 11.25C8.4375 9.35152 9.97652 7.8125 11.875 7.8125C13.7735 7.8125 15.3125 9.35152 15.3125 11.25C15.3125 13.1485 13.7735 14.6875 11.875 14.6875C9.97652 14.6875 8.4375 13.1485 8.4375 11.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function VisibilityOff() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M5.99969 19.7615L18.2941 3.54123"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7136 5.90849C16.2962 4.79882 14.362 4 11.875 4C8.81571 4 6.5928 5.2088 5.13945 6.71805C3.71592 8.19633 3 9.99942 3 11.25C3 12.5006 3.71592 14.3037 5.13945 15.7819C6.00576 16.6816 7.1455 17.4745 8.57283 17.9682L11.1222 14.6048C9.58579 14.2615 8.4375 12.8899 8.4375 11.25C8.4375 9.35152 9.97652 7.8125 11.875 7.8125C13.1831 7.8125 14.3206 8.54317 14.9015 9.61863L17.7136 5.90849ZM19.1461 7.32953L14.7749 13.0966C14.675 13.2532 14.5627 13.4011 14.4396 13.539L10.7243 18.4407C11.0938 18.4796 11.4773 18.5 11.875 18.5C14.9343 18.5 17.1572 17.2912 18.6106 15.7819C20.0341 14.3037 20.75 12.5006 20.75 11.25C20.75 10.1675 20.2136 8.67099 19.1461 7.32953ZM13.1202 11.9688C13.2425 11.7573 13.3125 11.5118 13.3125 11.25C13.3125 10.4561 12.6689 9.8125 11.875 9.8125C11.0811 9.8125 10.4375 10.4561 10.4375 11.25C10.4375 12.0439 11.0811 12.6875 11.875 12.6875C12.2787 12.6875 12.6436 12.5211 12.9047 12.2531L13.1202 11.9688Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Face() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
      />
    </SvgIcon>
  )
}

export function Home() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  )
}

export function HorseReacing() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
    >
      <path
        d="M2.67195 2.76722C3.53286 1.888 4.56118 1.19015 5.69623 0.714879C6.83127 0.239608 8.05002 -0.00345563 9.28055 3.7114e-05H9.96805C10.2415 3.7114e-05 10.5039 0.108686 10.6972 0.302083C10.8906 0.49548 10.9993 0.757783 10.9993 1.03129V3.20551L19.447 8.40473C19.5667 8.47895 19.6703 8.57657 19.7515 8.69174C19.8328 8.80692 19.8899 8.93728 19.9196 9.07504C19.9464 9.21487 19.9443 9.35872 19.9132 9.49767C19.8822 9.63663 19.8229 9.76773 19.7391 9.88285L18.5532 11.5243C18.2179 11.9962 17.7559 12.3637 17.2207 12.5842C16.6854 12.8047 16.0986 12.8692 15.5282 12.7703C14.4712 12.5899 12.6063 12.4352 10.8274 13.1141L12.6493 15.6664C13.1696 15.3912 13.6544 15.0535 14.093 14.661C14.297 14.4786 14.5651 14.3848 14.8383 14.4001C15.1114 14.4154 15.3674 14.5386 15.5497 14.7426C15.732 14.9466 15.8259 15.2147 15.8105 15.4878C15.7952 15.761 15.672 16.0169 15.468 16.1993C13.7677 17.7233 11.564 18.565 9.28055 18.5625H9.09148C7.27799 18.5254 5.51511 17.9578 4.02073 16.9297C2.52635 15.9016 1.36597 14.4581 0.683027 12.7777C8.01086e-05 11.0973 -0.175505 9.25365 0.177975 7.47455C0.531452 5.69545 1.3985 4.05892 2.67195 2.76722ZM4.16726 14.3602C4.99326 15.2023 6.01501 15.8268 7.14121 16.1777C8.26742 16.5286 9.46301 16.595 10.6212 16.3711L8.73055 13.7243C7.46637 13.5848 6.29785 12.9846 5.44817 12.0382C4.59849 11.0918 4.12719 9.86563 4.1243 8.59379C4.1243 8.32028 4.23294 8.05798 4.42634 7.86458C4.61974 7.67119 4.88204 7.56254 5.15555 7.56254C5.42905 7.56254 5.69135 7.67119 5.88475 7.86458C6.07815 8.05798 6.1868 8.32028 6.1868 8.59379C6.18625 9.37004 6.47754 10.1181 7.00287 10.6896C7.5282 11.2611 8.24917 11.6143 9.02273 11.6789C11.5665 10.2868 14.3852 10.4844 15.872 10.7336C16.0627 10.767 16.2589 10.746 16.4382 10.6731C16.6176 10.6001 16.7727 10.4781 16.886 10.3211L17.4188 9.58207L9.42664 4.65785C9.27707 4.56559 9.15355 4.43663 9.06782 4.28322C8.98209 4.1298 8.93699 3.95703 8.9368 3.78129V2.07113C7.54084 2.1333 6.19313 2.60023 5.05794 3.41502C3.92274 4.22981 3.04911 5.35725 2.54353 6.65992C2.03795 7.96258 1.92227 9.38419 2.21058 10.7515C2.49889 12.1187 3.17874 13.3726 4.16726 14.3602ZM7.90555 7.21879C7.90555 7.49074 7.98619 7.75658 8.13727 7.9827C8.28836 8.20881 8.50311 8.38505 8.75436 8.48912C9.0056 8.59319 9.28207 8.62042 9.54879 8.56737C9.81552 8.51431 10.0605 8.38336 10.2528 8.19106C10.4451 7.99876 10.5761 7.75376 10.6291 7.48704C10.6822 7.22031 10.655 6.94385 10.5509 6.6926C10.4468 6.44135 10.2706 6.2266 10.0445 6.07552C9.81834 5.92443 9.55249 5.84379 9.28055 5.84379C8.91587 5.84379 8.56614 5.98865 8.30827 6.24652C8.05041 6.50438 7.90555 6.85411 7.90555 7.21879Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Menu() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      />
    </SvgIcon>
  )
}

export function Lock() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      />
    </SvgIcon>
  )
}

export function Loyalty() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
      />
    </SvgIcon>
  )
}

export function LoyaltyColored() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="6.518%"
          x2="116.948%"
          y1="106.321%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#FFD87A" />
          <stop offset="100%" stopColor="#B532AB" />
        </linearGradient>
      </defs>
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="url(#gradient)"
        d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
      />
    </SvgIcon>
  )
}

export function Phone() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </SvgIcon>
  )
}

export function Remove() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13H5v-2h14v2z" />
    </SvgIcon>
  )
}

export function Room() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </SvgIcon>
  )
}

export function Search() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2221_20282)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3527 19.4752C15.5854 20.8025 13.3887 21.589 11.0084 21.589C5.16808 21.589 0.433594 16.8545 0.433594 11.0142C0.433594 5.17393 5.16808 0.439453 11.0084 0.439453C16.8486 0.439453 21.5831 5.17393 21.5831 11.0142C21.5831 13.3955 20.796 15.5929 19.4678 17.3605C19.4987 17.3869 19.5287 17.4147 19.5577 17.444L23.0925 21.0036C23.6763 21.5914 23.673 22.5412 23.0851 23.1249C22.4973 23.7086 21.5476 23.7053 20.9638 23.1175L17.429 19.5579C17.4024 19.5311 17.3769 19.5035 17.3527 19.4752ZM3.90981 9.36621C4.53113 9.36621 5.03481 9.86989 5.03481 10.4912C5.03481 12.8182 5.60124 14.0668 6.30235 14.8587C7.04725 15.7002 8.05742 16.1739 9.33368 16.7506C9.89989 17.0064 10.1515 17.6728 9.89566 18.239C9.63982 18.8052 8.97343 19.0569 8.40722 18.801L8.32799 18.7652C7.13914 18.2284 5.70866 17.5825 4.61766 16.3501C3.45853 15.0408 2.78481 13.2074 2.78481 10.4912C2.78481 9.86989 3.28849 9.36621 3.90981 9.36621ZM5.92185 7.27888C6.19884 6.72299 5.97253 6.04737 5.41636 5.76984C4.8602 5.49231 4.18479 5.71797 3.9078 6.27386L3.79137 6.50753C3.51438 7.06342 3.74069 7.73903 4.29686 8.01656C4.85302 8.29409 5.52843 8.06844 5.80542 7.51255L5.92185 7.27888Z"
          fill="#4D566D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2221_20282">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function Videocam() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      />
    </SvgIcon>
  )
}

export function ViewModule() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
      />
    </SvgIcon>
  )
}

export function ExpandMore() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function KeyboardArrowLeft() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M9 12L14 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12L14 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}

export function Info() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </SvgIcon>
  )
}

export function Warning() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
      />
    </SvgIcon>
  )
}

export function ExpandLess() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function PlayArrow() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M8 5v14l11-7z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Sports() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.3">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.15413 2.76629C6.18084 3.58912 4.52766 5.02606 3.43335 6.83838L7.92161 9.1029C8.74128 7.09153 8.82882 4.84691 8.15413 2.76629ZM2.75674 8.17711C2.2691 9.35485 2 10.646 2 12C2 12.8249 2.09988 13.6264 2.2882 14.3932C4.36212 13.6997 6.11515 12.2959 7.24586 10.4421L2.75674 8.17711ZM2.75503 15.8188C3.57587 17.8037 5.01737 19.4669 6.83762 20.5662L10.992 12.3322L8.58879 11.1196C7.2755 13.3284 5.208 15.0008 2.75503 15.8188ZM8.17629 21.2429C9.35425 21.7308 10.6457 22 12 22C12.8353 22 13.6466 21.8976 14.4222 21.7047C13.6252 19.2457 13.7423 16.5902 14.7369 14.2216L12.3312 13.0078L8.17629 21.2429ZM15.8463 21.2335C17.819 20.4108 19.4718 18.9744 20.566 17.1626L16.0799 14.8992C15.2622 16.9102 15.1743 19.1533 15.8463 21.2335ZM21.2428 15.824C21.7307 14.646 22 13.3544 22 12C22 11.1755 21.9002 10.3743 21.7121 9.60789C19.6394 10.3035 17.8872 11.7071 16.7556 13.56L21.2428 15.824ZM21.2454 8.18229C20.4246 6.19666 18.9827 4.53303 17.1619 3.43351L13.0069 11.6686L15.4126 12.8824C16.7269 10.6746 18.7936 9.00229 21.2454 8.18229ZM15.8232 2.75686L11.6677 10.993L9.26453 9.78046C10.2611 7.41152 10.378 4.75451 9.57827 2.29524C10.3537 2.10237 11.1649 2 12 2C13.3541 2 14.6454 2.26914 15.8232 2.75686Z"
          fill="#B2C2EE"
        />
      </g>
    </SvgIcon>
  )
}

export function Vip() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M1.35977 6.39708C1.38932 6.12087 1.73247 6.05316 1.8905 6.28161L4.5372 10.1077C5.2688 11.1653 6.86118 11.0707 7.46242 9.93393L11.3553 2.57368C11.4256 2.44064 11.5638 2.35742 11.7143 2.35742C11.8648 2.35742 12.0029 2.44064 12.0733 2.57368L15.9661 9.93393C16.5674 11.0707 18.1598 11.1653 18.8914 10.1077L21.5381 6.28161C21.6961 6.05316 22.0392 6.12088 22.0688 6.39709C22.2639 8.22025 22.4286 10.092 22.4286 12.0003C22.4286 13.9085 22.2639 15.7803 22.0688 17.6035C21.8046 20.0732 19.8182 22.0595 17.3497 22.3347C15.5162 22.539 13.6337 22.7146 11.7143 22.7146C9.79491 22.7146 7.91235 22.539 6.07884 22.3347C3.61035 22.0595 1.624 20.0732 1.35977 17.6035C1.16471 15.7803 1 13.9085 1 12.0003C1 10.092 1.16471 8.22025 1.35977 6.39708Z"
        fill="#B2C2EE"
      />
    </SvgIcon>
  )
}

export function Spinner() {
  return (
    <SvgIcon
      width="1em"
      height="1em"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g fill="none" fillRule="evenodd" strokeWidth="2">
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="0s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="0s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="-0.9s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="-0.9s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </SvgIcon>
  )
}

export function Roulette() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      width="1em"
      height="1em"
    >
      <g fill="none" fillRule="nonzero">
        <path
          fill="currentColor"
          d="M12.355 1.799a7.482 7.482 0 0 0-10.556.82 7.487 7.487 0 1 0 10.556-.82zm1.451 7.86l-2.288-.79c.308-.898.304-1.873 0-2.763l2.286-.787c.181.528.296 1.083.34 1.654a6.66 6.66 0 0 1-.338 2.686zm.129-4.403v-.001.001zm-1.413-2.151L10.7 4.687a4.24 4.24 0 0 0-2.393-1.382l.46-2.36a6.648 6.648 0 0 1 3.755 2.16zM5.215 1.21A6.59 6.59 0 0 1 6.21.94l.46 2.366a4.242 4.242 0 0 0-2.394 1.38L2.452 3.1a6.662 6.662 0 0 1 2.763-1.889zM1.168 5.315l2.288.789a4.276 4.276 0 0 0-.001 2.763l-2.288.788a6.718 6.718 0 0 1 0-4.34zm1.28 6.557l1.825-1.586a4.24 4.24 0 0 0 2.393 1.382l-.461 2.374a6.664 6.664 0 0 1-3.757-2.17zm7.31 1.897a6.678 6.678 0 0 1-.993.273l-.46-2.373a4.242 4.242 0 0 0 2.393-1.381l1.824 1.586a6.675 6.675 0 0 1-2.764 1.895z"
        />
        <g fill="currentColor" transform="translate(1 2)">
          <circle cx="3.716" cy=".702" r="1" />
          <circle cx=".957" cy="5.494" r="1" />
          <circle cx="3.728" cy="10.279" r="1" />
          <circle cx="9.258" cy="10.272" r="1" />
          <circle cx="12.016" cy="5.479" r="1" />
          <circle cx="9.245" cy=".694" r="1" />
        </g>
      </g>
    </svg>
  )
}

export function Done() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Create() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Language() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Refresh() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
        fill="currentColor"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </SvgIcon>
  )
}

export function Notifications() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Person() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function AllInclusive() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Article() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Favorite() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Casino() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_1179_16081)">
        <path
          d="M15.75 10.125C15.1287 10.125 14.625 10.6287 14.625 11.25C14.625 11.8713 15.1287 12.375 15.75 12.375C16.3713 12.375 16.875 11.8713 16.875 11.25C16.875 10.6287 16.3713 10.125 15.75 10.125Z"
          fill="#4D566D"
        />
        <path
          d="M3.75 10.125C3.12866 10.125 2.625 10.6287 2.625 11.25C2.625 11.8713 3.12866 12.375 3.75 12.375C4.37134 12.375 4.875 11.8713 4.875 11.25C4.875 10.6287 4.37134 10.125 3.75 10.125Z"
          fill="#4D566D"
        />
        <path
          d="M8.625 11.25C8.625 10.6287 9.12866 10.125 9.75 10.125C10.3713 10.125 10.875 10.6287 10.875 11.25C10.875 11.8713 10.3713 12.375 9.75 12.375C9.12866 12.375 8.625 11.8713 8.625 11.25Z"
          fill="#4D566D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.75 3.75H3.02759C3.33797 1.65015 6.22912 0 9.75 0C13.2709 0 16.162 1.65015 16.4724 3.75H17.75C18.7165 3.75 19.5 4.53352 19.5 5.5V18.6213C19.8134 18.5105 20.1014 18.3305 20.341 18.091C20.7629 17.669 21 17.0967 21 16.5V11.25C21 11.1853 21.0082 11.1226 21.0236 11.0627C20.5623 10.8068 20.25 10.3149 20.25 9.75C20.25 8.92157 20.9216 8.25 21.75 8.25C22.5784 8.25 23.25 8.92157 23.25 9.75C23.25 10.3149 22.9377 10.8068 22.4764 11.0627C22.4918 11.1226 22.5 11.1853 22.5 11.25V16.5C22.5 17.4945 22.1049 18.4484 21.4016 19.1516C20.8779 19.6754 20.2151 20.0283 19.5 20.1742V21.5C19.5 22.4665 18.7165 23.25 17.75 23.25H1.75C0.783516 23.25 0 22.4665 0 21.5V5.5C0 4.53351 0.783506 3.75 1.75 3.75ZM13.25 14.25H18V8.25H13.25V14.25ZM6.25 14.25V8.25H1.5V14.25H6.25ZM2.75 19.5C2.75 18.9477 3.19772 18.5 3.75 18.5H6.75C7.30228 18.5 7.75 18.9477 7.75 19.5C7.75 20.0523 7.30228 20.5 6.75 20.5H3.75C3.19772 20.5 2.75 20.0523 2.75 19.5ZM12.25 14.25H7.25V8.25H12.25V14.25Z"
          fill="#4D566D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1179_16081">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function LiveCasino() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g opacity="0.3">
        <path
          d="M4.25 8.25C4.25 7.83579 3.91421 7.5 3.5 7.5C3.08579 7.5 2.75 7.83579 2.75 8.25V11.25C2.75 13.0402 3.46116 14.7571 4.72703 16.023C5.9929 17.2888 7.70979 18 9.5 18H10.25V22.5H8C7.58579 22.5 7.25 22.8358 7.25 23.25C7.25 23.6642 7.58579 24 8 24H14C14.4142 24 14.75 23.6642 14.75 23.25C14.75 22.8358 14.4142 22.5 14 22.5H11.75V18H12.5C14.2902 18 16.0071 17.2888 17.273 16.023C18.5388 14.7571 19.25 13.0402 19.25 11.25V8.25C19.25 7.83579 18.9142 7.5 18.5 7.5C18.0858 7.5 17.75 7.83579 17.75 8.25V11.25C17.75 12.6424 17.1969 13.9777 16.2123 14.9623C15.2277 15.9469 13.8924 16.5 12.5 16.5H9.5C8.10761 16.5 6.77226 15.9469 5.78769 14.9623C4.80312 13.9777 4.25 12.6424 4.25 11.25V8.25Z"
          fill="#B2C2EE"
        />
        <path
          d="M9.50024 14.25H12.5002C13.3449 14.1985 14.1348 13.8144 14.6971 13.1819C15.2593 12.5494 15.5481 11.7199 15.5002 10.875V9C15.5002 9 15.5003 9 15.5002 9H12.5C12.0858 9 11.75 8.66421 11.75 8.25C11.75 7.83579 12.0858 7.5 12.5 7.5H15.5C15.4999 7.5 15.5001 7.5 15.5 7.5L15.5002 6C15.5002 6 15.5003 6 15.5002 6H12.5C12.0858 6 11.75 5.66421 11.75 5.25C11.75 4.83579 12.0858 4.5 12.5 4.5H15.5C15.4999 4.5 15.5001 4.5 15.5 4.5L15.5002 4.125C15.5481 3.28008 15.2593 2.45061 14.6971 1.8181C14.1348 1.18558 13.3449 0.801538 12.5002 0.75H9.50024C8.65554 0.801538 7.86565 1.18558 7.30341 1.8181C6.74118 2.45061 6.45239 3.28008 6.50024 4.125V4.5H9.5C9.91421 4.5 10.25 4.83579 10.25 5.25C10.25 5.66421 9.91421 6 9.5 6H6.50024V7.5H9.5C9.91421 7.5 10.25 7.83579 10.25 8.25C10.25 8.66421 9.91421 9 9.5 9H6.50024V10.875C6.45239 11.7199 6.74118 12.5494 7.30341 13.1819C7.86565 13.8144 8.65554 14.1985 9.50024 14.25Z"
          fill="#B2C2EE"
        />
      </g>
    </SvgIcon>
  )
}

export function Faq() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export function Wallet() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 64 64"
    >
      <g fill="currentColor">
        <path
          d="M10.1825 32.2013V25.455C10.1825 23.1674 11.9569 21.307 14.1987 21.1266L20.4639 10.1836C21.0445 9.17151 21.982 8.44815 23.1038 8.14778C24.2203 7.84945 25.3878 8.00613 26.3871 8.58775L47.8643 21.0914H51.6364C54.0429 21.0914 56 23.0484 56 25.455V51.6364C56 54.0429 54.043 56 51.6364 56H14.5461C12.1395 56 10.1825 54.043 10.1825 51.6364V44.8901C8.91542 44.4383 8.00071 43.2387 8.00071 41.8184V35.273C8.00071 33.8527 8.91542 32.6532 10.1825 32.2013ZM16.7339 21.0914H26.2422L19.1109 16.9396L16.7339 21.0914ZM20.1949 15.0463L30.5784 21.0914H34.8853L21.2718 13.1654L20.1949 15.0463ZM25.2888 10.4733C24.7956 10.1846 24.2193 10.1079 23.6684 10.255C23.1113 10.4041 22.6467 10.7642 22.358 11.2681L22.3558 11.2721L39.2213 21.0914H43.528L25.2888 10.4733ZM12.3643 51.6364C12.3643 52.8391 13.3433 53.8181 14.5461 53.8181H51.6364C52.8391 53.8181 53.8181 52.8391 53.8181 51.6364V25.455C53.8181 24.2523 52.8391 23.2733 51.6364 23.2733H14.5461C13.3433 23.2733 12.3643 24.2523 12.3643 25.455V32.0004H18.9097C22.519 32.0004 25.455 34.9364 25.455 38.5457C25.455 42.1551 22.519 45.0911 18.9097 45.0911H12.3643V51.6364ZM10.1825 41.8184C10.1825 42.4202 10.6714 42.9093 11.2734 42.9093H18.9097C21.3162 42.9093 23.2733 40.9523 23.2733 38.5457C23.2733 36.1392 21.3163 34.1821 18.9097 34.1821H11.2734C10.6715 34.1821 10.1825 34.6711 10.1825 35.273V41.8184Z"
          fill="currentColor"
        />
        <path
          d="M18.91 36.3633C20.1128 36.3633 21.0918 37.3423 21.0918 38.545C21.0918 39.7477 20.1128 40.7268 18.91 40.7268C17.7073 40.7268 16.7283 39.7477 16.7283 38.545C16.7282 37.3423 17.7072 36.3633 18.91 36.3633Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

export function Ball() {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0741 1.79212C11.7226 0.689534 10.0471 0.06006 8.30395 0C8.47338 0.999939 8.4299 2.02437 8.17635 3.00636C7.9228 3.98835 7.4649 4.90578 6.83256 5.69871L8.00005 6.86619L13.0741 1.79212ZM4.55292 5.68668L1.79217 2.92593C0.905649 4.01233 0.321487 5.31342 0.0986764 6.69781C0.870537 6.85055 1.66588 6.83948 2.43318 6.6653C3.20049 6.49112 3.92266 6.15771 4.55292 5.68668ZM14.2079 2.92593L9.13386 8L10.3013 9.16749C11.0943 8.53528 12.0118 8.07746 12.9937 7.82392C13.9757 7.57038 15.0001 7.52683 16 7.6961C15.94 5.95293 15.3105 4.27743 14.2079 2.92593ZM15.9014 9.3022C15.1296 9.14945 14.3342 9.16052 13.5669 9.3347C12.7996 9.50888 12.0774 9.84229 11.4472 10.3133L14.2079 13.0741C15.0949 11.988 15.6791 10.6867 15.9014 9.3022ZM5.68673 4.55287C6.15776 3.92261 6.49117 3.20044 6.66535 2.43313C6.83953 1.66583 6.8506 0.870488 6.69786 0.0986268C5.31335 0.32107 4.01218 0.905273 2.92598 1.79212L5.68673 4.55287ZM9.30225 15.9014C10.6866 15.6789 11.9877 15.095 13.0741 14.2087L10.3134 11.4479C9.84227 12.078 9.50882 12.8 9.33463 13.5672C9.16045 14.3344 9.14941 15.1296 9.30225 15.9014ZM8.00005 9.13381L2.92598 14.2079C4.27748 15.3105 5.95298 15.9399 7.69615 16C7.52673 15.0001 7.57021 13.9756 7.82375 12.9936C8.0773 12.0117 8.5352 11.0942 9.16754 10.3013L8.00005 9.13381ZM1.79217 13.0741L6.86624 8L5.69876 6.83252C4.90576 7.46472 3.98832 7.92254 3.00635 8.17608C2.02439 8.42962 0.99999 8.47317 4.95911e-05 8.3039C0.0601096 10.0471 0.689584 11.7226 1.79217 13.0741Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Moments() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 20"
    >
      <path
        d="M18.9202 2.67794C18.1383 1.91273 17.2566 1.5433 16.3337 1.5896C16.2736 1.59217 16.2113 1.59677 16.1452 1.6043V0.526972C16.1452 0.236368 15.902 0 15.6031 0L4.39737 0.00018381C4.09853 0.00018381 3.85527 0.236562 3.85527 0.527156V1.60411C3.79002 1.59694 3.72844 1.59216 3.66763 1.58959C2.72803 1.54529 1.8599 1.91475 1.08018 2.67793C0.0309681 3.70449 -0.27658 5.24372 0.257416 6.79452C0.912247 8.69748 2.57715 10.1935 4.71708 10.8056C5.50975 12.1079 6.80108 13.0878 8.27986 13.5107V15.0475H6.603C6.45937 15.0475 6.3196 15.1045 6.21824 15.2032L4.87285 16.5202C4.84235 16.55 4.81493 16.5853 4.78521 16.6356C4.78405 16.6373 4.77227 16.6599 4.77131 16.6614C4.74833 16.7077 4.73366 16.7481 4.72459 16.7963C4.7188 16.8274 4.71494 16.8593 4.71494 16.8919V18.473C4.71494 18.7636 4.95818 19 5.25704 19H14.7424C15.0413 19 15.2845 18.7636 15.2845 18.473L15.2832 16.963C15.2869 16.9395 15.2898 16.9163 15.2898 16.8919C15.2898 16.7259 15.212 16.573 15.0905 16.4848L13.7809 15.2031C13.6799 15.1042 13.5398 15.0474 13.3961 15.0474H11.7193L11.7194 13.5107C13.1982 13.0882 14.4896 12.1081 15.2824 10.8056C17.4218 10.1937 19.0867 8.69787 19.7423 6.79453C20.2766 5.24373 19.9693 3.70488 18.9201 2.67795L18.9202 2.67794ZM18.2045 6.29202C17.8682 7.26861 17.0748 8.17734 16.0541 8.76793C16.1147 8.4266 16.1453 8.08233 16.1453 7.74081V3.20308C16.2346 3.18378 16.3203 3.17275 16.4051 3.16907L16.4671 3.16779C16.914 3.16779 17.34 3.37218 17.77 3.7931C18.3852 4.39546 18.5437 5.30621 18.2045 6.29197L18.2045 6.29202ZM2.23063 3.79348C2.66132 3.37219 3.08294 3.16741 3.52003 3.16741C3.54281 3.16741 3.56578 3.16796 3.58972 3.16925C3.67582 3.17274 3.76327 3.18395 3.85536 3.20344V7.74117C3.85536 8.08324 3.88586 8.42733 3.94667 8.7681C2.92603 8.17789 2.13217 7.26897 1.79626 6.29219C1.45707 5.30681 1.61537 4.39601 2.23063 3.79346V3.79348Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Star() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function ExitFullscreen() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="none"
      width="28"
      height="28"
    >
      <path
        d="M21.5 11.375h-4.375V7M23.25 5.25l-6.125 6.125M7.5 16.625h4.375V21M5.75 22.75l6.125-6.125M17.125 21v-4.375H21.5M23.25 22.75l-6.125-6.125M11.875 7v4.375H7.5M5.75 5.25l6.125 6.125"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
export function Fullscreen() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      fill="none"
      width="28"
      height="28"
    >
      <path
        d="M18.875 5.25h4.375v4.375M17.125 11.375 23.25 5.25M10.125 22.75H5.75v-4.375M11.875 16.625 5.75 22.75M23.25 18.375v4.375h-4.375M17.125 16.625l6.125 6.125M5.75 9.625V5.25h4.375M11.875 11.375 5.75 5.25"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function GamesMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 16 16"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.27665 1.46626L8.27664 1.46626L4.26827 5.47494L4.26827 5.47495C3.41542 6.32787 2.98899 6.75433 2.76104 7.21436C2.32734 8.08965 2.32736 9.11727 2.7611 9.99254C2.78322 10.0372 2.80721 10.0815 2.83327 10.1259C3.16666 10.6941 3.33336 10.9782 3.71425 11.027C4.09514 11.0758 4.38547 10.7855 4.96613 10.2048L5.418 9.75296C5.64708 9.52388 6.01849 9.52388 6.24757 9.75296C6.47666 9.98205 6.47666 10.3535 6.24757 10.5825L5.79572 11.0344C5.21504 11.6151 4.9247 11.9054 4.97351 12.2863C5.02232 12.6672 5.30644 12.8339 5.87466 13.1672C5.91903 13.1932 5.96329 13.2172 6.00787 13.2393C6.88319 13.673 7.91088 13.673 8.78618 13.2392C9.24622 13.0112 9.67268 12.5848 10.5256 11.7318L10.5256 11.7318L14.5339 7.72318C15.0749 7.1821 15.3454 6.91156 15.5389 6.59585C15.7104 6.31594 15.8368 6.01078 15.9134 5.69157C15.9999 5.33153 15.9999 4.94895 15.9999 4.18378L15.9999 3.75425C15.9999 2.44014 15.9999 1.78308 15.7441 1.28116C15.5192 0.839654 15.1602 0.4807 14.7187 0.255742C14.2168 0 13.5597 0 12.2456 0H11.8163C11.0511 0 10.6684 0 10.3084 0.0864506C9.98913 0.163097 9.68394 0.289516 9.40402 0.461066C9.08829 0.654558 8.81774 0.925125 8.27665 1.46626ZM13 5.0205C13 6.13519 12.0964 7.03882 10.9817 7.03882C9.86699 7.03882 8.96337 6.13519 8.96337 5.02051C8.96336 3.90582 9.86699 3.00219 10.9817 3.00219C12.0964 3.00219 13 3.90582 13 5.0205ZM3.06332 5.1164C2.797 5.38275 2.66385 5.51592 2.50739 5.57548C2.36948 5.62798 2.21953 5.64039 2.07486 5.61128C1.91074 5.57826 1.75749 5.4688 1.45101 5.24987L1.451 5.24987L0.77829 4.76934C0.364726 4.47392 0.157943 4.32622 0.0711187 4.13677C-0.00507323 3.97053 -0.0206035 3.78284 0.0272272 3.60633C0.0817327 3.4052 0.261424 3.22551 0.620808 2.86614L0.892954 2.594C1.41239 2.07457 1.67211 1.81486 1.97946 1.65071C2.25155 1.50539 2.54962 1.41515 2.85662 1.38514C3.2034 1.35125 3.56356 1.42328 4.28388 1.56736L5.07764 1.72612C5.45003 1.8006 5.63622 1.83784 5.72334 1.93602C5.79923 2.02155 5.83388 2.136 5.81819 2.24926C5.80017 2.37927 5.66591 2.51355 5.39739 2.78209L3.06332 5.1164ZM13.4071 15.1083C13.9267 14.5888 14.1864 14.3291 14.3506 14.0217C14.4959 13.7495 14.5862 13.4514 14.6161 13.1443C14.65 12.7975 14.5779 12.4373 14.4337 11.7169L14.2748 10.923C14.2003 10.5506 14.163 10.3645 14.0648 10.2774C13.9793 10.2015 13.8648 10.1668 13.7516 10.1825C13.6216 10.2006 13.4873 10.3349 13.2188 10.6034L10.8848 12.9377L10.8848 12.9378C10.6185 13.2041 10.4854 13.3372 10.4259 13.4937C10.3734 13.6316 10.361 13.7815 10.3901 13.9262C10.4231 14.0903 10.5325 14.2435 10.7514 14.5499L11.232 15.2227C11.5274 15.6363 11.6751 15.8431 11.8646 15.9299C12.0308 16.0061 12.2185 16.0217 12.395 15.9738C12.5962 15.9193 12.7758 15.7396 13.1352 15.3803L13.4071 15.1083Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

GamesMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function LiveCasinoMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 19 17"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5367 7.62549L14.5173 2.00131C14.5135 0.896745 13.615 0.00439619 12.5105 0.00819077L11.3904 0.0120387L14.5367 7.62549ZM1.95784 3.08511C0.939257 3.51237 0.459897 4.68447 0.887164 5.70305L4.6972 14.786C5.12446 15.8046 6.29656 16.2839 7.31515 15.8567L12.6417 13.6223C13.6603 13.1951 14.1397 12.023 13.7124 11.0044L9.90239 1.92143C9.47513 0.902843 8.30303 0.423484 7.28445 0.850751L1.95784 3.08511ZM6.50666 5.38754C6.20932 5.19034 5.80705 5.35908 5.73938 5.70939L5.10915 8.97184C5.07087 9.17003 5.1555 9.3718 5.32372 9.48336L8.09282 11.3199C8.39016 11.5171 8.79243 11.3484 8.8601 10.998L9.49032 7.73559C9.52861 7.53741 9.44397 7.33564 9.27575 7.22407L6.50666 5.38754ZM18.5907 4.46568L16.3731 9.63459L16.5117 1.39748L17.5412 1.83915C18.5563 2.27465 19.0262 3.45059 18.5907 4.46568Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

LiveCasinoMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function PromotionsMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 16 16"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6028 2.56291C11.6028 1.97588 11.1269 1.5 10.5399 1.5H10.4817C9.98664 1.5 9.55018 1.82474 9.40792 2.29895L9.1226 3.25H11.3509C11.508 3.06472 11.6028 2.82488 11.6028 2.56291ZM13.0097 3.25C13.0704 3.03133 13.1028 2.80091 13.1028 2.56291C13.1028 1.14745 11.9554 0 10.5399 0H10.4817C9.35773 0 8.36297 0.715931 8.00177 1.77254C7.64058 0.715931 6.64581 0 5.52182 0H5.46364C4.04819 0 2.90073 1.14745 2.90073 2.56291C2.90073 2.80091 2.93317 3.03133 2.99387 3.25H2.00011C1.03362 3.25 0.250114 4.0335 0.250114 5C0.250114 5.9665 1.03362 6.75 2.00011 6.75H14.0001C14.9666 6.75 15.7501 5.9665 15.7501 5C15.7501 4.0335 14.9666 3.25 14.0001 3.25H13.0097ZM4.65263 3.25C4.4955 3.06472 4.40073 2.82488 4.40073 2.56291C4.40073 1.97588 4.87661 1.5 5.46364 1.5H5.52182C6.01691 1.5 6.45337 1.82474 6.59563 2.29895L6.88095 3.25H4.65263ZM3.62063 8.24988L3.7144 8.25H12.2858L12.3796 8.24988C12.7617 8.24914 13.127 8.24844 13.4442 8.35943C14.0043 8.55543 14.4447 8.99582 14.6407 9.55596C14.7517 9.87314 14.751 10.2384 14.7502 10.6205L14.7501 10.7143L14.7502 10.8633C14.7506 11.9156 14.7509 12.6349 14.5397 13.2385C14.1628 14.3157 13.3158 15.1626 12.2387 15.5396C11.635 15.7508 10.9157 15.7505 9.86336 15.75L9.7144 15.75H6.28583L6.13687 15.75C5.08451 15.7505 4.36522 15.7508 3.76157 15.5396C2.68439 15.1626 1.83747 14.3157 1.46055 13.2385C1.24933 12.6349 1.24963 11.9156 1.25007 10.8632L1.25011 10.7143L1.24999 10.6205C1.24926 10.2384 1.24855 9.87314 1.35954 9.55596C1.55554 8.99582 1.99594 8.55543 2.55607 8.35943C2.87326 8.24844 3.23852 8.24914 3.62063 8.24988Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

PromotionsMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function SupportMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="1.143em"
      viewBox="0 0 17 16"
    >
      <g opacity={props.inactive ? '1' : '0.55'}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00061 0C3.58202 0 4.95911e-05 3.58197 4.95911e-05 8.00056C4.95911e-05 9.19858 0.2641 10.337 0.737587 11.3591L1.41782 11.044L0.737587 11.3591C1.10178 12.1453 1.26605 12.5043 1.1201 13.0122L1.83787 13.2184L1.1201 13.0122C1.09199 13.11 1.05 13.201 0.983046 13.3462C0.961843 13.3922 0.938136 13.4436 0.911574 13.5023C0.819326 13.7064 0.689752 14.0088 0.661399 14.3541C0.582744 15.3117 1.4261 16.0877 2.37392 15.9298L2.25357 15.2074L2.37392 15.9298C2.87136 15.8469 3.30558 15.622 3.59368 15.4727C3.66002 15.4384 3.7186 15.408 3.76843 15.3843C4.05304 15.2491 4.26106 15.1905 4.58466 15.2666L4.58467 15.2666C4.58519 15.2667 4.60425 15.2716 4.65453 15.2877C4.70197 15.303 4.76508 15.3242 4.84803 15.353C5.01415 15.4107 5.24321 15.4926 5.55563 15.6043L5.79043 14.948L5.55563 15.6043C6.30463 15.8723 7.09985 16.0011 8.00061 16.0011C12.4192 16.0011 16.0012 12.4191 16.0012 8.00056C16.0012 3.58197 12.4192 0 8.00061 0ZM8.00005 5C7.44776 5 7.00005 5.44772 7.00005 6V6.5C7.00005 7.05228 6.55233 7.5 6.00005 7.5C5.44776 7.5 5.00005 7.05228 5.00005 6.5V6C5.00005 4.34315 6.3432 3 8.00005 3C9.6569 3 11 4.34315 11 6V6.12132C11 6.94915 10.6712 7.74307 10.0858 8.32843L8.70716 9.70711C8.31663 10.0976 7.68347 10.0976 7.29294 9.70711C6.90242 9.31658 6.90242 8.68342 7.29294 8.29289L8.67162 6.91421C8.88191 6.70393 9.00005 6.41871 9.00005 6.12132V6C9.00005 5.44772 8.55233 5 8.00005 5ZM8.00005 13C8.55233 13 9.00005 12.5523 9.00005 12C9.00005 11.4477 8.55233 11 8.00005 11C7.44776 11 7.00005 11.4477 7.00005 12C7.00005 12.5523 7.44776 13 8.00005 13Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  )
}

SupportMenu.propTypes = {
  inactive: PropTypes.bool,
}

export function ExpirationTimeIcon() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.416504 5.99972C0.416504 2.91592 2.91641 0.416016 6.00021 0.416016C9.08401 0.416016 11.5839 2.91592 11.5839 5.99972C11.5839 9.08352 9.08401 11.5834 6.00021 11.5834C2.91641 11.5834 0.416504 9.08352 0.416504 5.99972ZM6.5 2.99805C6.5 2.7219 6.27614 2.49805 6 2.49805C5.72386 2.49805 5.5 2.7219 5.5 2.99805V6.16471C5.5 6.32399 5.57588 6.47373 5.70432 6.56792L8.20432 8.40125C8.427 8.56455 8.7399 8.51641 8.9032 8.29373C9.0665 8.07105 9.01836 7.75815 8.79568 7.59484L6.5 5.91134V2.99805Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function EmptyOffersDrawer() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="117"
      viewBox="0 0 108 117"
    >
      <path
        d="M34.5 59H58.5V83H34.5V59Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 94H47.2868L58.5 83H34.7132L23.5 94Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 70.2132V94L34.5 82.7868V59L23.5 70.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 94V70.2132L58.5 59V82.7868L47.5 94Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.2868 70H23.5L34.7132 59H58.5L47.2868 70Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="23.5"
        y="70"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 70H47.5V94H23.5V70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 105H36.2868L47.5 94H23.7132L12.5 105Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 81.2132V105L23.5 93.7868V70L12.5 81.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 105V81.2132L47.5 70V93.7868L36.5 105Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.2868 81H12.5L23.7132 70H47.5L36.2868 81Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="12.5"
        y="81"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 81H36.5V105H12.5V81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 116H25.2868L36.5 105H12.7132L1.5 116Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 92.2132V116L12.5 104.787V81L1.5 92.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 116V92.2132L36.5 81V104.787L25.5 116Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.2868 92H1.5L12.7132 81H36.5L25.2868 92Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="92"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M58.5 59H82.5V83H58.5V59Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 94H71.2868L82.5 83H58.7132L47.5 94Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70.2132V94L58.5 82.7868V59L47.5 70.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 94V70.2132L82.5 59V82.7868L71.5 94Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.2868 70H47.5L58.7132 59H82.5L71.2868 70Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="70"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70H71.5V94H47.5V70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 105H60.2868L71.5 94H47.7132L36.5 105Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81.2132V105L47.5 93.7868V70L36.5 81.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 105V81.2132L71.5 70V93.7868L60.5 105Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.2868 81H36.5L47.7132 70H71.5L60.2868 81Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="36.5"
        y="81"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81H60.5V105H36.5V81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 116H49.2868L60.5 105H36.7132L25.5 116Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 92.2132V116L36.5 104.787V81L25.5 92.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 116V92.2132L60.5 81V104.787L49.5 116Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.2868 92H25.5L36.7132 81H60.5L49.2868 92Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25.5"
        y="92"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M82.5 59H106.5V83H82.5V59Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 94H95.2868L106.5 83H82.7132L71.5 94Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70.2132V94L82.5 82.7868V59L71.5 70.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.5 94V70.2132L106.5 59V82.7868L95.5 94Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.2868 70H71.5L82.7132 59H106.5L95.2868 70Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="71.5"
        y="70"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70H95.5V94H71.5V70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 105H84.2868L95.5 94H71.7132L60.5 105Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81.2132V105L71.5 93.7868V70L60.5 81.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.5 105V81.2132L95.5 70V93.7868L84.5 105Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.2868 81H60.5L71.7132 70H95.5L84.2868 81Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="60.5"
        y="81"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81H84.5V105H60.5V81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 116H73.2868L84.5 105H60.7132L49.5 116Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 92.2132V116L60.5 104.787V81L49.5 92.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 116V92.2132L84.5 81V104.787L73.5 116Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.2868 92H49.5L60.7132 81H84.5L73.2868 92Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="49.5"
        y="92"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 35H58.5V59H34.5V35Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 70H47.2868L58.5 59H34.7132L23.5 70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 46.2132V70L34.5 58.7868V35L23.5 46.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70V46.2132L58.5 35V58.7868L47.5 70Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.2868 46H23.5L34.7132 35H58.5L47.2868 46Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="23.5"
        y="46"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 46H47.5V70H23.5V46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 81H36.2868L47.5 70H23.7132L12.5 81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 57.2132V81L23.5 69.7868V46L12.5 57.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81V57.2132L47.5 46V69.7868L36.5 81Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.2868 57H12.5L23.7132 46H47.5L36.2868 57Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="12.5"
        y="57"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 57H36.5V81H12.5V57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 92H25.2868L36.5 81H12.7132L1.5 92Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 68.2132V92L12.5 80.7868V57L1.5 68.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 92V68.2132L36.5 57V80.7868L25.5 92Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.2868 68H1.5L12.7132 57H36.5L25.2868 68Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="68"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M58.5 35H82.5V59H58.5V35Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 70H71.2868L82.5 59H58.7132L47.5 70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46.2132V70L58.5 58.7868V35L47.5 46.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70V46.2132L82.5 35V58.7868L71.5 70Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.2868 46H47.5L58.7132 35H82.5L71.2868 46Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="46"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46H71.5V70H47.5V46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 81H60.2868L71.5 70H47.7132L36.5 81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57.2132V81L47.5 69.7868V46L36.5 57.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81V57.2132L71.5 46V69.7868L60.5 81Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.2868 57H36.5L47.7132 46H71.5L60.2868 57Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="36.5"
        y="57"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57H60.5V81H36.5V57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 92H49.2868L60.5 81H36.7132L25.5 92Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 68.2132V92L36.5 80.7868V57L25.5 68.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 92V68.2132L60.5 57V80.7868L49.5 92Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.2868 68H25.5L36.7132 57H60.5L49.2868 68Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25.5"
        y="68"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M82.5 35H106.5V59H82.5V35Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 70H95.2868L106.5 59H82.7132L71.5 70Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46.2132V70L82.5 58.7868V35L71.5 46.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.5 70V46.2132L106.5 35V58.7868L95.5 70Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.2868 46H71.5L82.7132 35H106.5L95.2868 46Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="71.5"
        y="46"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46H95.5V70H71.5V46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 81H84.2868L95.5 70H71.7132L60.5 81Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57.2132V81L71.5 69.7868V46L60.5 57.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.5 81V57.2132L95.5 46V69.7868L84.5 81Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.2868 57H60.5L71.7132 46H95.5L84.2868 57Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="60.5"
        y="57"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57H84.5V81H60.5V57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 92H73.2868L84.5 81H60.7132L49.5 92Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 68.2132V92L60.5 80.7868V57L49.5 68.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 92V68.2132L84.5 57V80.7868L73.5 92Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.2868 68H49.5L60.7132 57H84.5L73.2868 68Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="49.5"
        y="68"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 11H58.5V35H34.5V11Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 46H47.2868L58.5 35H34.7132L23.5 46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 22.2132V46L34.5 34.7868V11L23.5 22.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46V22.2132L58.5 11V34.7868L47.5 46Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.2868 22H23.5L34.7132 11H58.5L47.2868 22Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="23.5"
        y="22"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 22H47.5V46H23.5V22Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 57H36.2868L47.5 46H23.7132L12.5 57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 33.2132V57L23.5 45.7868V22L12.5 33.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57V33.2132L47.5 22V45.7868L36.5 57Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.2868 33H12.5L23.7132 22H47.5L36.2868 33Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="12.5"
        y="33"
        width="24"
        height="24"
        fill="#A1E5E5"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 1H36.5V25H12.5V1Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 36H25.2868L36.5 25H12.7132L1.5 36Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 12.2132V36L12.5 24.7868V1L1.5 12.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 36V12.2132L36.5 1V24.7868L25.5 36Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.2868 12H1.5L12.7132 1H36.5L25.2868 12Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="12"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M58.5 11H82.5V35H58.5V11Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 46H71.2868L82.5 35H58.7132L47.5 46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 22.2132V46L58.5 34.7868V11L47.5 22.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46V22.2132L82.5 11V34.7868L71.5 46Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.2868 22H47.5L58.7132 11H82.5L71.2868 22Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="47.5"
        y="22"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M47.5 22H71.5V46H47.5V22Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 57H60.2868L71.5 46H47.7132L36.5 57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 33.2132V57L47.5 45.7868V22L36.5 33.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57V33.2132L71.5 22V45.7868L60.5 57Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.2868 33H36.5L47.7132 22H71.5L60.2868 33Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="36.5"
        y="33"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 33H60.5V57H36.5V33Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 68H49.2868L60.5 57H36.7132L25.5 68Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 44.2132V68L36.5 56.7868V33L25.5 44.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 68V44.2132L60.5 33V56.7868L49.5 68Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.2868 44H25.5L36.7132 33H60.5L49.2868 44Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25.5"
        y="44"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M82.5 11H106.5V35H82.5V11Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 46H95.2868L106.5 35H82.7132L71.5 46Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 22.2132V46L82.5 34.7868V11L71.5 22.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.5 46V22.2132L106.5 11V34.7868L95.5 46Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M95.2868 22H71.5L82.7132 11H106.5L95.2868 22Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="71.5"
        y="22"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M71.5 22H95.5V46H71.5V22Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 57H84.2868L95.5 46H71.7132L60.5 57Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 33.2132V57L71.5 45.7868V22L60.5 33.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.5 57V33.2132L95.5 22V45.7868L84.5 57Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M84.2868 33H60.5L71.7132 22H95.5L84.2868 33Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="60.5"
        y="33"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M60.5 33H84.5V57H60.5V33Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 68H73.2868L84.5 57H60.7132L49.5 68Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 44.2132V68L60.5 56.7868V33L49.5 44.2132Z"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.5 68V44.2132L84.5 33V56.7868L73.5 68Z"
        fill="#A1E6E6"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M73.2868 44H49.5L60.7132 33H84.5L73.2868 44Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="49.5"
        y="44"
        width="24"
        height="24"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function EmptyPromotionDrawer() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="119"
      viewBox="0 0 120 119"
    >
      <rect
        x="5.5"
        y="5"
        width="109"
        height="109"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="1.5"
        y="1"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <rect
        x="1.5"
        y="110"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <rect
        x="110.5"
        y="1"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <rect
        x="110.5"
        y="110"
        width="8"
        height="8"
        rx="1"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
      />
      <path
        d="M75 95V45L95 24V74.0107L75 95Z"
        fill="#A1E5E5"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M75 45H25L45.3303 24H95L75 45Z"
        fill="#CEF0F0"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="25"
        y="45"
        width="50"
        height="50"
        fill="white"
        stroke="#88B8C2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function Lobby() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
    >
      <path
        d="M1 7.98257L1.06169 12.8737C1.19101 14.0195 2.10965 14.9327 3.26104 15.0655C4.30783 15.1862 5.39613 15.2692 6.5 15.3145V12.3268C6.5 11.2223 7.39543 10.3268 8.5 10.3268C9.60457 10.3268 10.5 11.2223 10.5 12.3268V15.3145C11.6039 15.2692 12.6922 15.1862 13.739 15.0655C14.8903 14.9327 15.809 14.0195 15.9383 12.8737L16 7.98257C14.1392 4.9578 12.6119 3.19365 9.4023 0.965793C8.86023 0.589528 8.13977 0.589527 7.5977 0.965792C4.38811 3.19364 2.86081 4.9578 1 7.98257Z"
        fill="#4D566D"
      />
    </SvgIcon>
  )
}

export function JoinUs() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Login" opacity="0.8" clipPath="url(#clip0_1089_10621)">
        <path
          id="Intersect"
          d="M4.41502 6.14383C4.43831 5.44462 4.46783 4.75368 4.50336 4.072C4.56783 2.83495 5.65972 1.81901 7.087 1.72203C8.38407 1.6339 9.72006 1.58789 11.0846 1.58789C12.4491 1.58789 13.7851 1.6339 15.0822 1.72203C16.5095 1.81901 17.6014 2.83496 17.6659 4.072C17.7654 5.98255 17.8179 7.96587 17.8179 10C17.8179 12.0341 17.7654 14.0174 17.6659 15.928C17.6014 17.165 16.5095 18.181 15.0822 18.278C13.7851 18.3661 12.4491 18.4121 11.0846 18.4121C9.72006 18.4121 8.38407 18.3661 7.087 18.278C5.65972 18.181 4.56783 17.165 4.50336 15.928C4.46783 15.2463 4.43831 14.5554 4.41502 13.8562"
          stroke="white"
          strokeWidth="2.44716"
          strokeLinecap="round"
        />
        <path
          id="Vector"
          d="M8.31877 9.99968C8.31877 10.6352 8.40429 11.5084 8.49939 12.2829C8.61668 13.238 9.56979 13.8526 10.4526 13.4695C11.8395 12.8677 13.116 11.9969 14.0378 10.7587C14.3736 10.3076 14.3736 9.69177 14.0379 9.24066C13.1161 8.00235 11.8396 7.1316 10.4527 6.52983C9.56988 6.1468 8.61679 6.76126 8.49947 7.71639C8.40432 8.49092 8.31877 9.3641 8.31877 9.99968Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M1.09176 10L8.61719 10"
          stroke="white"
          strokeWidth="1.4683"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1089_10621">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Promo() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
    >
      <path
        d="M1.93332 1.58871C2.92995 -0.280003 5.5844 -0.374346 6.71676 1.40576L8.01124 3.18568L9.28149 1.40856C10.4129 -0.374445 13.0696 -0.28098 14.0667 1.58871C14.7752 2.9171 14.2746 4.54686 12.979 5.26967C13.8443 5.6382 14.4626 6.46197 14.5596 7.44384C14.5917 7.76857 14.6193 8.0958 14.6419 8.42572H8.75002V4.91602C9.33267 4.92234 9.88501 4.93629 10.4105 4.95829L12.147 4.01214L12.1795 3.99542C12.8238 3.68409 13.073 2.91305 12.7432 2.29459C12.2864 1.4382 11.0556 1.39645 10.5414 2.22283L10.5147 2.26274L8.62666 4.90419L7.40995 4.90919L5.48891 2.26773L5.45867 2.22283C4.94447 1.39645 3.71359 1.4382 3.25685 2.29459C2.92739 2.91234 3.17561 3.68231 3.81829 3.99434L5.83186 4.94878C6.28423 4.93221 6.75624 4.92137 7.25002 4.91602V8.42572H1.35817C1.3807 8.0958 1.40833 7.76857 1.4404 7.44384C1.53738 6.46197 2.15574 5.63819 3.02106 5.26967C1.72546 4.54686 1.22485 2.9171 1.93332 1.58871Z"
        fill="#4D566D"
      />
      <path
        d="M3.80487 15.7165C4.83126 15.809 5.96716 15.8599 7.25002 15.8738V9.92572H1.29356C1.29091 10.0815 1.28955 10.2378 1.28955 10.3949C1.28955 11.4037 1.34557 12.3857 1.44041 13.346C1.5647 14.6044 2.54542 15.6031 3.80487 15.7165Z"
        fill="#4D566D"
      />
      <path
        d="M12.1952 15.7165C11.1688 15.809 10.0329 15.8599 8.75002 15.8738V9.92572H14.7065C14.7091 10.0815 14.7105 10.2378 14.7105 10.3949C14.7105 11.4037 14.6545 12.3857 14.5596 13.346C14.4353 14.6044 13.4546 15.6031 12.1952 15.7165Z"
        fill="#4D566D"
      />
    </SvgIcon>
  )
}

export function Browse() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_1596_4534)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5681 12.9834C10.3899 13.8683 8.92545 14.3926 7.33854 14.3926C3.44502 14.3926 0.288696 11.2363 0.288696 7.34281C0.288696 3.44929 3.44502 0.292969 7.33854 0.292969C11.2321 0.292969 14.3884 3.44929 14.3884 7.34281C14.3884 8.93031 13.8637 10.3953 12.9782 11.5737C12.9987 11.5913 13.0187 11.6098 13.0381 11.6294L15.3947 14.0024C15.7838 14.3943 15.7816 15.0274 15.3897 15.4166C14.9978 15.8058 14.3647 15.8036 13.9755 15.4117L11.619 13.0386C11.6012 13.0207 11.5842 13.0023 11.5681 12.9834ZM2.60617 6.24414C3.02038 6.24414 3.35617 6.57993 3.35617 6.99414C3.35617 8.54544 3.73379 9.37784 4.2012 9.90583C4.6978 10.4668 5.37124 10.7826 6.22209 11.1671C6.59956 11.3376 6.76729 11.7819 6.59674 12.1594C6.42618 12.5368 5.98192 12.7046 5.60445 12.534L5.55163 12.5102C4.75906 12.1523 3.8054 11.7217 3.07807 10.9001C2.30532 10.0272 1.85617 8.80496 1.85617 6.99414C1.85617 6.57993 2.19196 6.24414 2.60617 6.24414ZM3.94753 4.85258C4.13219 4.48199 3.98132 4.03158 3.61054 3.84656C3.23977 3.66154 2.7895 3.81198 2.60483 4.18257L2.52721 4.33835C2.34255 4.70894 2.49343 5.15936 2.8642 5.34437C3.23498 5.52939 3.68525 5.37896 3.86991 5.00836L3.94753 4.85258Z"
          fill="#4D566D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1596_4534">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function MenuNav() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <rect
        x="0.433228"
        y="6.68164"
        width="15.1336"
        height="2.99023"
        rx="1"
        fill="#4D566D"
      />
      <rect
        x="0.433228"
        y="1.52344"
        width="15.1336"
        height="2.99023"
        rx="1"
        fill="#4D566D"
      />
      <rect
        x="0.433228"
        y="11.8359"
        width="15.1336"
        height="2.99023"
        rx="1"
        fill="#4D566D"
      />
    </SvgIcon>
  )
}

export function Chevron() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="10"
      viewBox="0 0 18 10"
    >
      <path
        d="M2 1.5L9 8.5L16 1.5"
        stroke="#B2C2EE"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}

export function BuyCoins() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <g opacity="0.8" clipPath="url(#clip0_1596_4538)">
        <mask id="path-1-inside-1_1596_4538" fill="white">
          <path d="M12.7877 20.5049C12.8795 21.1104 12.4626 21.682 11.8508 21.7097C10.0193 21.7926 8.19079 21.3964 6.54952 20.5511C4.57837 19.5359 2.97768 17.9248 1.97531 15.9471C0.972935 13.9694 0.61996 11.7259 0.966629 9.53598C1.3133 7.34603 2.34194 5.32125 3.90614 3.74984C5.47033 2.17844 7.49037 1.1405 9.67869 0.783762C11.867 0.427028 14.1121 0.769683 16.0944 1.76295C18.0767 2.75622 19.6951 4.34948 20.7194 6.31594C21.5722 7.95331 21.9768 9.77993 21.9023 11.6118C21.8774 12.2238 21.3078 12.6433 20.7018 12.5543C20.0959 12.4652 19.6846 11.9007 19.6924 11.2883C19.7096 9.92065 19.3893 8.5637 18.7522 7.34054C17.9436 5.78801 16.6658 4.53012 15.1008 3.74593C13.5358 2.96174 11.7632 2.69122 10.0356 2.97286C8.30786 3.2545 6.71304 4.07396 5.4781 5.31459C4.24316 6.55522 3.43104 8.1538 3.15734 9.88277C2.88365 11.6117 3.16232 13.383 3.9537 14.9444C4.74508 16.5058 6.00883 17.7778 7.56506 18.5792C8.79114 19.2107 10.1495 19.5248 11.5171 19.5012C12.1295 19.4907 12.6958 19.8993 12.7877 20.5049Z" />
        </mask>
        <path
          d="M12.7877 20.5049C12.8795 21.1104 12.4626 21.682 11.8508 21.7097C10.0193 21.7926 8.19079 21.3964 6.54952 20.5511C4.57837 19.5359 2.97768 17.9248 1.97531 15.9471C0.972935 13.9694 0.61996 11.7259 0.966629 9.53598C1.3133 7.34603 2.34194 5.32125 3.90614 3.74984C5.47033 2.17844 7.49037 1.1405 9.67869 0.783762C11.867 0.427028 14.1121 0.769683 16.0944 1.76295C18.0767 2.75622 19.6951 4.34948 20.7194 6.31594C21.5722 7.95331 21.9768 9.77993 21.9023 11.6118C21.8774 12.2238 21.3078 12.6433 20.7018 12.5543C20.0959 12.4652 19.6846 11.9007 19.6924 11.2883C19.7096 9.92065 19.3893 8.5637 18.7522 7.34054C17.9436 5.78801 16.6658 4.53012 15.1008 3.74593C13.5358 2.96174 11.7632 2.69122 10.0356 2.97286C8.30786 3.2545 6.71304 4.07396 5.4781 5.31459C4.24316 6.55522 3.43104 8.1538 3.15734 9.88277C2.88365 11.6117 3.16232 13.383 3.9537 14.9444C4.74508 16.5058 6.00883 17.7778 7.56506 18.5792C8.79114 19.2107 10.1495 19.5248 11.5171 19.5012C12.1295 19.4907 12.6958 19.8993 12.7877 20.5049Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          mask="url(#path-1-inside-1_1596_4538)"
        />
        <path
          d="M14.3081 13.0137C14.3081 13.5992 14.122 14.0916 13.7499 14.491C13.3822 14.8858 12.874 15.1445 12.225 15.267V15.5393C12.225 15.9867 11.8623 16.3494 11.4149 16.3494C10.9675 16.3494 10.6048 15.9867 10.6048 15.5393V15.3011C9.87443 15.2143 9.26793 15.0238 8.7853 14.7296C8.57119 14.5991 8.5104 14.3258 8.61224 14.0966L8.66344 13.9814C8.79416 13.6873 9.18814 13.5967 9.46793 13.7557C9.69939 13.8828 9.96488 13.9917 10.2644 14.0825C10.5639 14.1687 10.868 14.2119 11.1766 14.2119C11.5533 14.2119 11.871 14.1279 12.1297 13.96C12.3929 13.7875 12.5245 13.5175 12.5245 13.1499C12.5245 12.9457 12.4474 12.7732 12.293 12.6325C12.1433 12.4918 11.9595 12.3784 11.7416 12.2921C11.5238 12.2014 11.2402 12.1061 10.8907 12.0062C10.4187 11.8701 10.0103 11.7067 9.66535 11.5161C9.32044 11.3255 9.03906 11.0691 8.82122 10.7468C8.60338 10.4201 8.49446 10.0139 8.49446 9.52829C8.49446 9.16523 8.57615 8.83393 8.73953 8.5344C8.90745 8.23033 9.14798 7.97391 9.46113 7.76515C9.77881 7.55639 10.16 7.41343 10.6048 7.33628V6.82572C10.6048 6.37832 10.9675 6.01562 11.4149 6.01562C11.8623 6.01562 12.225 6.37832 12.225 6.82572V7.34309C12.6107 7.4157 12.9466 7.52689 13.2325 7.67665C13.3739 7.74956 13.4948 7.82246 13.5954 7.89537C13.7634 8.01726 13.7836 8.24436 13.6879 8.42861L13.5093 8.77249C13.4126 8.9586 13.1244 9.00635 12.9466 8.8952C12.765 8.7772 12.5495 8.67509 12.2999 8.58886C12.0548 8.49809 11.8074 8.45271 11.5578 8.45271C11.1721 8.45271 10.8476 8.53667 10.5844 8.70459C10.3257 8.8725 10.1963 9.11531 10.1963 9.43299C10.1963 9.77336 10.3438 10.0343 10.6388 10.2159C10.9338 10.3928 11.3037 10.5313 11.7484 10.6311C12.5063 10.8081 13.1213 11.0986 13.5933 11.5025C14.0698 11.9064 14.3081 12.4101 14.3081 13.0137Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7143 23.4023C21.3473 23.4023 23.4818 21.2678 23.4818 18.6347C23.4818 16.0017 21.3473 13.8672 18.7143 13.8672C16.0812 13.8672 13.9467 16.0017 13.9467 18.6347C13.9467 21.2678 16.0812 23.4023 18.7143 23.4023ZM18.7143 16.2266C19.1285 16.2266 19.4643 16.5624 19.4643 16.9766V17.8872H20.3743C20.7886 17.8872 21.1243 18.223 21.1243 18.6372C21.1243 19.0515 20.7886 19.3872 20.3743 19.3872H19.4643V20.2967C19.4643 20.711 19.1285 21.0467 18.7143 21.0467C18.3001 21.0467 17.9643 20.711 17.9643 20.2967V19.3872H17.0542C16.64 19.3872 16.3042 19.0515 16.3042 18.6372C16.3042 18.223 16.64 17.8872 17.0542 17.8872H17.9643V16.9766C17.9643 16.5624 18.3001 16.2266 18.7143 16.2266Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1596_4538">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function MyAccount() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.10279 7.52485C10.082 7.52485 11.6865 5.92036 11.6865 3.94113C11.6865 1.9619 10.082 0.357422 8.10279 0.357422C6.12356 0.357422 4.51907 1.9619 4.51907 3.94113C4.51907 5.92036 6.12356 7.52485 8.10279 7.52485ZM5.41757 9.02725C3.26023 9.02725 1.51135 10.7761 1.51135 12.9335C1.51135 14.3717 2.67727 15.5376 4.1155 15.5376H12.4142C13.8524 15.5376 15.0183 14.3717 15.0183 12.9335C15.0183 10.7761 13.2694 9.02725 11.1121 9.02725H5.41757Z"
        fill="#4D566D"
      />
    </SvgIcon>
  )
}

export function GoldCoin() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#clip0_1482_16632)">
        <path
          d="M10.5024 0.021796L8.09549 0.200595C8.07773 0.201914 8.05997 0.203307 8.04225 0.204739C8.03617 0.205234 8.0301 0.205758 8.02403 0.206264C8.01241 0.207238 8.00079 0.208212 7.98919 0.209226C7.98192 0.209871 7.97465 0.210534 7.96737 0.211192C7.9569 0.21214 7.94644 0.213096 7.93599 0.214087C7.92855 0.214792 7.9211 0.215506 7.91366 0.216237C7.90301 0.217272 7.89236 0.218328 7.88173 0.219412C7.87468 0.220126 7.86763 0.220847 7.8606 0.221576C7.84962 0.222718 7.83865 0.223901 7.8277 0.225088C7.82083 0.225832 7.81397 0.226563 7.80712 0.227323C7.79501 0.22867 7.78289 0.230061 7.7708 0.231464C7.76536 0.232094 7.75991 0.232702 7.75446 0.233339C7.73705 0.235394 7.71963 0.237498 7.70226 0.239665C7.69809 0.240185 7.69391 0.240739 7.68973 0.241265C7.67644 0.242946 7.66315 0.244638 7.64987 0.24638C7.64272 0.247315 7.63559 0.248293 7.62845 0.249254C7.6183 0.250609 7.60814 0.251983 7.598 0.25338C7.58988 0.254499 7.58177 0.255654 7.57367 0.256795C7.56442 0.258102 7.55517 0.259415 7.54594 0.260757C7.53752 0.261978 7.52911 0.263217 7.5207 0.264462C7.51189 0.265767 7.50308 0.267088 7.49429 0.268423C7.48554 0.269748 7.47679 0.271079 7.46805 0.27244C7.4593 0.273795 7.45055 0.275182 7.44183 0.276567C7.43343 0.277895 7.42502 0.27922 7.41664 0.280579C7.40705 0.282131 7.3975 0.283719 7.38794 0.285306C7.38012 0.286605 7.37228 0.287875 7.36446 0.289198C7.34818 0.291947 7.33193 0.294738 7.3157 0.297588C7.30687 0.299133 7.29805 0.300733 7.28924 0.302309C7.28111 0.303765 7.27297 0.305204 7.26486 0.306678C7.25522 0.308437 7.24559 0.310226 7.23597 0.31202C7.22857 0.313393 7.22116 0.314771 7.21375 0.316168C7.20425 0.317966 7.19478 0.319781 7.18529 0.321608C7.17773 0.323065 7.17017 0.324536 7.16261 0.326011C7.15296 0.327907 7.1433 0.329808 7.13366 0.331733C7.12673 0.333119 7.11982 0.334515 7.11289 0.335914C7.10264 0.337995 7.09239 0.340075 7.08214 0.342193C7.07629 0.3434 7.07042 0.344634 7.06459 0.345854C7.05341 0.348193 7.04223 0.350526 7.03106 0.352908C7.02813 0.353538 7.0252 0.354185 7.02227 0.354813C7.00118 0.359344 6.98012 0.363951 6.9591 0.368649C6.93807 0.373346 6.91708 0.378126 6.89612 0.38299C6.89298 0.383714 6.88983 0.38444 6.88668 0.385171C6.87412 0.388104 6.86157 0.391078 6.84902 0.394073C6.84525 0.394974 6.84147 0.395868 6.8377 0.396773C6.82503 0.39982 6.81236 0.402895 6.79971 0.405995C6.79635 0.406821 6.793 0.407647 6.78965 0.408473C6.77644 0.411731 6.76325 0.415018 6.75007 0.41834C6.74786 0.418898 6.74564 0.419461 6.74344 0.420023C6.72914 0.423638 6.71487 0.427312 6.70062 0.431002C6.69549 0.432335 6.69037 0.433679 6.68524 0.43501C6.67562 0.437529 6.666 0.440061 6.65639 0.442608C6.65105 0.444031 6.6457 0.445446 6.64036 0.44688C6.62875 0.449981 6.61717 0.453113 6.60559 0.456267C6.60088 0.457556 6.59616 0.458838 6.59145 0.460135C6.5799 0.463304 6.56837 0.466499 6.55685 0.469717C6.55035 0.471532 6.54385 0.473364 6.53735 0.475203C6.52989 0.477304 6.52243 0.479428 6.51497 0.481553C6.50791 0.483569 6.50086 0.485584 6.4938 0.487617C6.48633 0.489773 6.47885 0.491955 6.47136 0.494138C6.45891 0.497769 6.44646 0.50143 6.43403 0.505121C6.42768 0.50701 6.42133 0.508887 6.41498 0.510794C6.40651 0.513332 6.39805 0.515892 6.38957 0.518468C6.38466 0.519956 6.37974 0.52145 6.37483 0.522956C6.36587 0.525689 6.35691 0.528434 6.34796 0.531205C6.34431 0.532335 6.34064 0.533478 6.33699 0.534621C6.31728 0.540754 6.2976 0.546946 6.27797 0.553227C6.27659 0.553662 6.27523 0.554094 6.27387 0.554527C6.26401 0.557682 6.25415 0.560869 6.24431 0.564066C6.24091 0.565166 6.23751 0.566271 6.23411 0.567384C6.22382 0.570736 6.21355 0.5741 6.20329 0.577496L6.20295 0.577607C6.18991 0.58192 6.17688 0.586281 6.16387 0.590658C6.15938 0.592163 6.1549 0.593681 6.15042 0.595198C6.14083 0.598439 6.13126 0.601702 6.1217 0.604983C6.11777 0.606323 6.11386 0.607652 6.10997 0.608996C6.09812 0.613073 6.08628 0.617185 6.07447 0.621321C6.06875 0.623324 6.06305 0.62533 6.05734 0.627343C6.04979 0.630002 6.04225 0.632679 6.0347 0.635363C6.02889 0.637433 6.02309 0.63949 6.01729 0.641572C6.00637 0.645481 5.99545 0.649415 5.98456 0.653372C5.97737 0.65598 5.9702 0.658617 5.96302 0.66125C5.95777 0.663173 5.95254 0.665095 5.94731 0.667023C5.93986 0.669774 5.93241 0.672523 5.92497 0.675297C5.92057 0.676931 5.91619 0.678589 5.91179 0.680228C5.89723 0.685684 5.88268 0.691178 5.86816 0.696711C5.865 0.697915 5.86183 0.699119 5.85866 0.700324C5.84966 0.703772 5.84066 0.707226 5.83168 0.710703C5.83036 0.711219 5.82904 0.711728 5.82771 0.712244C5.81072 0.71882 5.79378 0.725472 5.77686 0.732159C5.77244 0.733905 5.76802 0.735669 5.76362 0.73742C5.7504 0.742672 5.73719 0.747954 5.724 0.753271C5.72004 0.754873 5.71606 0.756476 5.71208 0.758084C5.67716 0.772245 5.64233 0.786636 5.60764 0.801271C5.60666 0.801687 5.60568 0.802104 5.6047 0.80252C5.58817 0.809498 5.57166 0.81654 5.55519 0.82363C5.55314 0.824511 5.55109 0.825388 5.54906 0.82627C2.05233 2.33399 -0.287028 6.29087 0.0284365 10.7408C0.369118 15.5464 3.69248 19.3254 7.78476 19.9187C7.78773 19.9191 7.79068 19.9195 7.79365 19.9199C7.81043 19.9224 7.82724 19.9247 7.84408 19.927C7.84769 19.9275 7.85129 19.928 7.85491 19.9285C7.87451 19.9312 7.89411 19.9338 7.91375 19.9363C7.91422 19.9364 7.91469 19.9364 7.91516 19.9365C7.92592 19.9379 7.93669 19.9392 7.94748 19.9406C7.94901 19.9408 7.95055 19.9409 7.95208 19.9411C7.96905 19.9432 7.98604 19.9453 8.00305 19.9472C8.00907 19.9479 8.0151 19.9486 8.02113 19.9493C8.02855 19.9502 8.03595 19.951 8.04337 19.9518C8.05313 19.9529 8.06288 19.954 8.07266 19.955C8.07965 19.9558 8.08667 19.9565 8.09368 19.9573C8.10421 19.9584 8.11476 19.9595 8.1253 19.9605C8.13033 19.961 8.13537 19.9615 8.14041 19.962C8.15473 19.9634 8.16903 19.9648 8.18337 19.9662L8.18623 19.9664C8.19718 19.9675 8.20815 19.9684 8.21909 19.9694C8.22235 19.9697 8.22559 19.97 8.22885 19.9703C8.2473 19.9719 8.26578 19.9734 8.28429 19.9749C8.28814 19.9752 8.29202 19.9755 8.29588 19.9758C8.3046 19.9765 8.31331 19.9772 8.32203 19.9778C8.32884 19.9784 8.33566 19.9789 8.34247 19.9794C8.35 19.9799 8.35753 19.9804 8.36506 19.981C8.37849 19.9819 8.39192 19.9828 8.40536 19.9837C8.41085 19.984 8.41633 19.9844 8.42183 19.9847C8.43183 19.9853 8.44184 19.9859 8.45187 19.9865C8.45734 19.9869 8.46283 19.9872 8.46831 19.9875C8.48329 19.9883 8.49828 19.9892 8.51327 19.9899C8.51415 19.99 8.51503 19.99 8.51591 19.99C8.53003 19.9908 8.54416 19.9914 8.55831 19.9921L8.5603 19.9922C8.60165 19.994 8.64306 19.9955 8.68452 19.9967C8.68786 19.9968 8.69121 19.9969 8.69453 19.997C8.70595 19.9973 8.71738 19.9976 8.72881 19.9979C8.73404 19.998 8.73926 19.9981 8.74449 19.9982C8.75539 19.9985 8.76629 19.9987 8.7772 19.9989C8.78247 19.9989 8.78774 19.999 8.79302 19.9991C8.81497 19.9994 8.83695 19.9997 8.85894 19.9998C8.8627 19.9998 8.86645 19.9999 8.87021 19.9999C8.87949 20 8.88877 20 8.89807 20C8.90582 20 8.91359 20 8.92137 20C8.93017 20 8.93899 20 8.9478 19.9999C8.95619 19.9999 8.96458 19.9998 8.97299 19.9997C8.98125 19.9997 8.98953 19.9996 8.9978 19.9995C9.00799 19.9994 9.01819 19.9993 9.02841 19.9991C9.03611 19.999 9.04379 19.9989 9.0515 19.9988C9.06654 19.9985 9.0816 19.9982 9.09667 19.9978C9.10309 19.9977 9.10952 19.9975 9.11595 19.9973C9.12685 19.9971 9.13774 19.9968 9.14864 19.9964C9.15552 19.9962 9.16239 19.996 9.16926 19.9958C9.17987 19.9954 9.1905 19.9951 9.20112 19.9947C9.20779 19.9944 9.21447 19.9942 9.22114 19.9939C9.23513 19.9934 9.24914 19.9928 9.26314 19.9922C9.26614 19.992 9.26913 19.9919 9.27214 19.9918C9.28898 19.991 9.30583 19.9902 9.32269 19.9893C9.32839 19.989 9.33409 19.9887 9.33981 19.9883C9.35158 19.9877 9.36339 19.9871 9.37518 19.9864C9.38127 19.986 9.38735 19.9856 9.39344 19.9853C9.40552 19.9845 9.41763 19.9837 9.42975 19.983C9.43509 19.9826 9.44043 19.9823 9.44578 19.9819C9.46303 19.9807 9.4803 19.9795 9.49758 19.9782L11.9045 19.7994C16.747 19.4397 20.3587 14.7207 19.9716 9.25928C19.5844 3.79784 15.3449 -0.337928 10.5024 0.021796Z"
          fill="#F1CB3D"
        />
        <path
          d="M18.2611 9.38591C18.4388 11.8928 17.5697 14.2053 16.067 15.7833C14.9348 16.9722 13.4432 17.7442 11.7688 17.8686L11.7682 17.8686C11.7537 17.8697 11.7392 17.8707 11.7246 17.8718C11.7226 17.8719 11.7204 17.872 11.7183 17.8721C11.7051 17.873 11.6918 17.8738 11.6786 17.8747C11.6776 17.8748 11.6765 17.8747 11.6755 17.8748C11.6611 17.8757 11.6466 17.8764 11.6322 17.8773L11.6316 17.8773C11.6173 17.878 11.6031 17.8787 11.589 17.8794C11.5874 17.8795 11.5859 17.8795 11.5844 17.8796C11.575 17.88 11.5657 17.8804 11.5564 17.8808C11.5475 17.8811 11.5386 17.8815 11.5297 17.8818C11.5048 17.8827 11.48 17.8834 11.4551 17.8839C11.5431 17.8729 11.6307 17.8603 11.7177 17.8458C7.85375 18.1029 4.48051 14.7949 4.17125 10.4326C4.07036 9.00949 4.30795 7.64931 4.80785 6.45131C5.04583 5.88117 5.34333 5.34769 5.69197 4.8617C6.49076 3.74824 7.5587 2.88413 8.79674 2.39836C9.36405 2.1758 9.96697 2.03262 10.5962 1.98133C10.5072 1.97983 10.4178 1.98007 10.3281 1.98231C10.3307 1.98199 10.3335 1.98166 10.3362 1.98134C10.4368 1.96857 10.5382 1.95871 10.6403 1.95111C11.3177 1.9008 11.9804 1.95992 12.6147 2.11474C13.5484 2.34277 14.4205 2.77842 15.1874 3.3793C16.8971 4.71879 18.0834 6.87887 18.2611 9.38591Z"
          fill="#F5E13C"
        />
        <path
          d="M2.43537 10.5616C2.33682 9.1716 2.49735 7.82966 2.87127 6.59544C3.03671 6.04936 3.24391 5.52437 3.48894 5.02563C3.91846 4.15144 4.4642 3.35793 5.10486 2.67288C6.51825 1.16152 8.39362 0.178136 10.5024 0.0214844L8.09549 0.200283C8.07773 0.201602 8.05997 0.202995 8.04225 0.204427C8.03617 0.204922 8.0301 0.205446 8.02403 0.205953C8.01241 0.206927 8.00079 0.2079 7.98919 0.208915C7.98192 0.20956 7.97465 0.210223 7.96737 0.21088C7.9569 0.211828 7.94644 0.212784 7.93599 0.213775C7.92855 0.21448 7.9211 0.215194 7.91366 0.215925C7.90301 0.216961 7.89236 0.218017 7.88173 0.2191C7.87468 0.219814 7.86763 0.220535 7.8606 0.221265C7.84962 0.222407 7.83865 0.223589 7.8277 0.224777C7.82083 0.22552 7.81397 0.226251 7.80712 0.227011C7.79501 0.228358 7.78289 0.229749 7.7708 0.231152C7.76536 0.231782 7.75991 0.23239 7.75446 0.233027C7.73705 0.235082 7.71963 0.237186 7.70226 0.239354C7.69809 0.239873 7.69391 0.240428 7.68973 0.240954C7.67644 0.242634 7.66315 0.244327 7.64987 0.246068C7.64272 0.247004 7.63559 0.247981 7.62845 0.248942C7.6183 0.250298 7.60814 0.251671 7.598 0.253069C7.58988 0.254187 7.58177 0.255342 7.57367 0.256484C7.56442 0.25779 7.55517 0.259103 7.54594 0.260446C7.53752 0.261667 7.52911 0.262905 7.5207 0.26415C7.51189 0.265455 7.50308 0.266777 7.49429 0.268111C7.48554 0.269436 7.47679 0.270768 7.46805 0.272128C7.4593 0.273484 7.45055 0.27487 7.44183 0.276255C7.43343 0.277584 7.42502 0.278908 7.41664 0.280267C7.40705 0.28182 7.3975 0.283408 7.38794 0.284994C7.38012 0.286294 7.37228 0.287564 7.36446 0.288886C7.34818 0.291635 7.33193 0.294426 7.3157 0.297277C7.30687 0.298822 7.29805 0.300421 7.28924 0.301997C7.28111 0.303453 7.27297 0.304893 7.26486 0.306366C7.25522 0.308125 7.24559 0.309914 7.23597 0.311708C7.22857 0.313081 7.22116 0.314459 7.21375 0.315857C7.20425 0.317655 7.19478 0.319469 7.18529 0.321297C7.17773 0.322754 7.17017 0.324224 7.16261 0.3257C7.15296 0.327595 7.1433 0.329496 7.13366 0.331421C7.12673 0.332807 7.11982 0.334204 7.11289 0.335602C7.10264 0.337684 7.09239 0.339764 7.08214 0.341882C7.07629 0.343089 7.07042 0.344322 7.06459 0.345542C7.05341 0.347881 7.04223 0.350215 7.03106 0.352597C7.02813 0.353227 7.0252 0.353873 7.02227 0.354502C7.00118 0.359032 6.98012 0.363639 6.9591 0.368337C6.93807 0.373034 6.91708 0.377815 6.89612 0.382679C6.89298 0.383402 6.88983 0.384128 6.88668 0.384859C6.87412 0.387792 6.86157 0.390767 6.84902 0.393762C6.84525 0.394662 6.84147 0.395557 6.8377 0.396461C6.82503 0.399508 6.81236 0.402584 6.79971 0.405683C6.79635 0.40651 6.793 0.407335 6.78965 0.408161C6.77644 0.411419 6.76325 0.414706 6.75007 0.418028C6.74786 0.418586 6.74564 0.419149 6.74344 0.419711C6.72914 0.423326 6.71487 0.427 6.70062 0.430691C6.69549 0.432024 6.69037 0.433367 6.68524 0.434699C6.67562 0.437218 6.666 0.439749 6.65639 0.442296C6.65105 0.443719 6.6457 0.445135 6.64036 0.446568C6.62875 0.44967 6.61717 0.452801 6.60559 0.455956C6.60088 0.457244 6.59616 0.458527 6.59145 0.459823C6.5799 0.462993 6.56837 0.466187 6.55685 0.469406C6.55035 0.471221 6.54385 0.473052 6.53735 0.474892C6.52989 0.476992 6.52243 0.479117 6.51497 0.481241C6.50791 0.483257 6.50086 0.485272 6.4938 0.487305C6.48633 0.489462 6.47885 0.491643 6.47136 0.493826C6.45891 0.497457 6.44646 0.501118 6.43403 0.504809C6.42768 0.506698 6.42133 0.508575 6.41498 0.510482C6.40651 0.51302 6.39805 0.515581 6.38957 0.518156C6.38466 0.519644 6.37974 0.521138 6.37483 0.522645C6.36587 0.525377 6.35691 0.528122 6.34796 0.530893C6.34431 0.532023 6.34064 0.533166 6.33699 0.534309C6.31728 0.540442 6.2976 0.546635 6.27797 0.552916C6.27659 0.55335 6.27523 0.553782 6.27387 0.554215C6.26401 0.55737 6.25415 0.560558 6.24431 0.563754C6.24091 0.564855 6.23751 0.565959 6.23411 0.567072C6.22382 0.570425 6.21355 0.573789 6.20329 0.577184L6.20295 0.577295C6.18991 0.581608 6.17688 0.585969 6.16387 0.590346C6.15938 0.591852 6.1549 0.593369 6.15042 0.594886C6.14083 0.598127 6.13126 0.60139 6.1217 0.604671C6.11777 0.606011 6.11386 0.60734 6.10997 0.608684C6.09812 0.612761 6.08628 0.616874 6.07447 0.621009C6.06875 0.623012 6.06305 0.625018 6.05734 0.627031C6.04979 0.62969 6.04225 0.632367 6.0347 0.635051C6.02889 0.637122 6.02309 0.639179 6.01729 0.64126C6.00637 0.645169 5.99545 0.649103 5.98456 0.653061C5.97737 0.655668 5.9702 0.658305 5.96302 0.660938C5.95777 0.662861 5.95254 0.664783 5.94731 0.666712C5.93986 0.669462 5.93241 0.672211 5.92497 0.674985C5.92057 0.676619 5.91619 0.678277 5.91179 0.679916C5.89723 0.685372 5.88268 0.690866 5.86816 0.696399C5.865 0.697603 5.86183 0.698807 5.85866 0.700012C5.84966 0.70346 5.84066 0.706914 5.83168 0.710392C5.83036 0.710908 5.82904 0.711417 5.82771 0.711933C5.81072 0.718509 5.79378 0.72516 5.77686 0.731847C5.77244 0.733594 5.76802 0.735357 5.76362 0.737108C5.7504 0.74236 5.73719 0.747642 5.724 0.75296C5.72004 0.754562 5.71606 0.756165 5.71208 0.757772C5.67716 0.771934 5.64233 0.786325 5.60764 0.800959C5.60666 0.801376 5.60568 0.801792 5.6047 0.802209C5.58817 0.809186 5.57166 0.816228 5.55519 0.823318C5.55314 0.8242 5.55109 0.825076 5.54906 0.825958C2.05233 2.33368 -0.287028 6.29055 0.0284365 10.7404C0.369118 15.546 3.69248 19.3251 7.78476 19.9184C7.78773 19.9188 7.79068 19.9192 7.79365 19.9196C7.81043 19.9221 7.82724 19.9244 7.84408 19.9267C7.84769 19.9272 7.85129 19.9277 7.85491 19.9282C7.87451 19.9309 7.89411 19.9335 7.91375 19.936C7.91422 19.9361 7.91469 19.9361 7.91516 19.9362C7.92592 19.9376 7.93669 19.9389 7.94748 19.9403C7.94901 19.9404 7.95055 19.9406 7.95208 19.9408C7.96905 19.9429 7.98604 19.9449 8.00305 19.9469C8.00907 19.9476 8.0151 19.9483 8.02113 19.949C8.02855 19.9499 8.03595 19.9507 8.04337 19.9515C8.05313 19.9526 8.06288 19.9537 8.07266 19.9547C8.07965 19.9555 8.08667 19.9562 8.09368 19.957C8.10421 19.9581 8.11476 19.9591 8.1253 19.9602C8.13033 19.9607 8.13537 19.9612 8.14041 19.9617C8.15473 19.9631 8.16903 19.9645 8.18337 19.9659L8.18623 19.9661C8.19718 19.9671 8.20815 19.9681 8.21909 19.9691C8.22235 19.9694 8.22559 19.9697 8.22885 19.97C8.2473 19.9716 8.26578 19.9731 8.28429 19.9746C8.28814 19.9749 8.29202 19.9752 8.29588 19.9755C8.3046 19.9762 8.31331 19.9769 8.32203 19.9775C8.32884 19.978 8.33566 19.9785 8.34247 19.979C8.35 19.9796 8.35753 19.9801 8.36506 19.9807C8.37849 19.9816 8.39192 19.9825 8.40536 19.9834C8.41085 19.9837 8.41633 19.9841 8.42183 19.9844C8.43183 19.985 8.44184 19.9856 8.45187 19.9862C8.45734 19.9865 8.46283 19.9869 8.46831 19.9872C8.48329 19.988 8.49828 19.9888 8.51327 19.9896C8.51415 19.9896 8.51503 19.9897 8.51591 19.9897C8.53003 19.9905 8.54416 19.9911 8.55831 19.9918L8.5603 19.9918C8.60165 19.9937 8.64306 19.9952 8.68452 19.9964C8.68786 19.9965 8.69121 19.9966 8.69453 19.9967C8.70595 19.997 8.71738 19.9973 8.72881 19.9976C8.73404 19.9977 8.73926 19.9978 8.74449 19.9979C8.75539 19.9981 8.76629 19.9984 8.7772 19.9985C8.78247 19.9986 8.78774 19.9987 8.79302 19.9988C8.81497 19.9991 8.83695 19.9994 8.85894 19.9995C8.8627 19.9995 8.86645 19.9996 8.87021 19.9996C8.87949 19.9996 8.88877 19.9996 8.89807 19.9997C8.90582 19.9997 8.91359 19.9997 8.92137 19.9997C8.93017 19.9997 8.93899 19.9996 8.9478 19.9996C8.95619 19.9996 8.96458 19.9995 8.97299 19.9994C8.98125 19.9994 8.98953 19.9993 8.9978 19.9992C9.00799 19.9991 9.01819 19.999 9.02841 19.9988C9.03611 19.9987 9.04379 19.9986 9.0515 19.9985C9.06654 19.9982 9.0816 19.9979 9.09667 19.9975C9.10309 19.9974 9.10952 19.9972 9.11595 19.997C9.12685 19.9967 9.13774 19.9964 9.14864 19.9961C9.15552 19.9959 9.16239 19.9957 9.16926 19.9955C9.17987 19.9951 9.1905 19.9947 9.20112 19.9944C9.20779 19.9941 9.21447 19.9939 9.22114 19.9936C9.23513 19.9931 9.24914 19.9925 9.26314 19.9918C9.26614 19.9917 9.26913 19.9916 9.27214 19.9915C9.28898 19.9907 9.30583 19.9898 9.32269 19.989C9.32839 19.9887 9.33409 19.9883 9.33981 19.988C9.35158 19.9874 9.36339 19.9867 9.37518 19.986C9.38127 19.9857 9.38735 19.9853 9.39344 19.985C9.40552 19.9842 9.41763 19.9834 9.42975 19.9826C9.43509 19.9823 9.44043 19.982 9.44578 19.9816C9.46303 19.9804 9.4803 19.9792 9.49758 19.9779L11.9045 19.7991C9.97932 19.9421 8.14946 19.3746 6.61908 18.2957C4.30001 16.6609 2.66862 13.8518 2.43537 10.5616Z"
          fill="#E6913A"
        />
        <path
          d="M4.21355 18.4756C5.39084 19.3054 6.74513 19.8329 8.18377 19.967L8.18662 19.9673C8.19758 19.9683 8.20854 19.9693 8.21948 19.9703C8.22275 19.9705 8.22598 19.9708 8.22924 19.9711C8.2477 19.9727 8.26617 19.9743 8.28468 19.9757C8.28854 19.9761 8.29241 19.9764 8.29627 19.9767C8.30499 19.9774 8.3137 19.978 8.32242 19.9787C8.32923 19.9792 8.33606 19.9797 8.34286 19.9802C8.35039 19.9807 8.35792 19.9813 8.36545 19.9818C8.37888 19.9828 8.39232 19.9837 8.40576 19.9845C8.41124 19.9849 8.41672 19.9852 8.42222 19.9856C8.43223 19.9862 8.44223 19.9868 8.45226 19.9874C8.45773 19.9877 8.46322 19.988 8.46871 19.9883C8.48368 19.9892 8.49867 19.99 8.51366 19.9908C8.51454 19.9908 8.51543 19.9908 8.51631 19.9909C8.53042 19.9916 8.54455 19.9923 8.5587 19.9929L8.5607 19.993C8.60205 19.9948 8.64346 19.9964 8.68492 19.9976C8.68826 19.9977 8.6916 19.9978 8.69492 19.9979C8.70634 19.9982 8.71777 19.9984 8.7292 19.9987C8.73443 19.9988 8.73966 19.999 8.74489 19.9991C8.75578 19.9993 8.76669 19.9995 8.77759 19.9997C8.78286 19.9998 8.78814 19.9999 8.79342 19.9999C8.81537 20.0003 8.83734 20.0005 8.85933 20.0007C8.86309 20.0007 8.86684 20.0007 8.8706 20.0007C8.87988 20.0008 8.88916 20.0008 8.89846 20.0008C8.90622 20.0008 8.91399 20.0008 8.92176 20.0008C8.93056 20.0008 8.93938 20.0008 8.9482 20.0008C8.95659 20.0007 8.96498 20.0007 8.97338 20.0006C8.98164 20.0005 8.98993 20.0005 8.99819 20.0004C9.00839 20.0003 9.01859 20.0001 9.02881 20C9.0365 19.9998 9.04419 19.9997 9.05189 19.9996C9.06694 19.9993 9.08199 19.999 9.09707 19.9987C9.10348 19.9985 9.10991 19.9983 9.11634 19.9982C9.12724 19.9979 9.13814 19.9976 9.14903 19.9973C9.15591 19.9971 9.16279 19.9968 9.16966 19.9966C9.18027 19.9963 9.19089 19.9959 9.20152 19.9955C9.20818 19.9953 9.21486 19.995 9.22153 19.9948C9.23552 19.9942 9.24953 19.9936 9.26354 19.993C9.26653 19.9929 9.26953 19.9927 9.27253 19.9926C9.28937 19.9918 9.30622 19.991 9.32308 19.9901C9.32878 19.9898 9.33448 19.9895 9.3402 19.9892C9.35198 19.9886 9.36378 19.9879 9.37558 19.9872C9.38166 19.9868 9.38774 19.9865 9.39383 19.9861C9.40592 19.9854 9.41803 19.9846 9.43014 19.9838C9.43548 19.9834 9.44082 19.9831 9.44618 19.9827C9.46343 19.9816 9.48069 19.9804 9.49797 19.9791L11.9049 19.8003C9.97972 19.9433 8.14986 19.3758 6.61947 18.2969L4.21355 18.4756Z"
          fill="#E37838"
        />
        <path
          d="M0.466141 6.77394L2.87233 6.59519C3.03777 6.04912 3.24496 5.52412 3.48999 5.02539L1.08384 5.20413C0.838767 5.70286 0.63167 6.2279 0.466141 6.77394Z"
          fill="#EAA83C"
        />
        <path
          d="M5.10445 2.67288C6.51785 1.16152 8.39321 0.178136 10.502 0.0214844L8.09508 0.200283C8.07733 0.201602 8.05957 0.202995 8.04185 0.204427C8.03576 0.204922 8.0297 0.205446 8.02363 0.205953C8.012 0.206927 8.00039 0.2079 7.98879 0.208915C7.98151 0.20956 7.97424 0.210223 7.96697 0.21088C7.9565 0.211828 7.94604 0.212784 7.93559 0.213775C7.92815 0.21448 7.92069 0.215194 7.91325 0.215925C7.90261 0.216961 7.89196 0.218017 7.88132 0.2191C7.87428 0.219814 7.86723 0.220535 7.8602 0.221265C7.84922 0.222407 7.83825 0.223589 7.8273 0.224777C7.82043 0.22552 7.81357 0.226251 7.80672 0.227011C7.79461 0.228358 7.78249 0.229749 7.77039 0.231152C7.76495 0.231782 7.75951 0.23239 7.75406 0.233027C7.73664 0.235082 7.71923 0.237186 7.70186 0.239354C7.69768 0.239873 7.69351 0.240428 7.68933 0.240954C7.67604 0.242634 7.66274 0.244327 7.64947 0.246068C7.64232 0.247004 7.63519 0.247981 7.62805 0.248942C7.61789 0.250298 7.60773 0.251671 7.59759 0.253069C7.58948 0.254187 7.58136 0.255342 7.57326 0.256484C7.56402 0.25779 7.55477 0.259103 7.54554 0.260446C7.53712 0.261667 7.5287 0.262905 7.52029 0.26415C7.51149 0.265455 7.50268 0.266777 7.49389 0.268111C7.48514 0.269436 7.47639 0.270768 7.46765 0.272128C7.4589 0.273484 7.45015 0.27487 7.44143 0.276255C7.43302 0.277584 7.42461 0.278908 7.41624 0.280267C7.40665 0.28182 7.39709 0.283407 7.38754 0.284994C7.37972 0.286294 7.37187 0.287564 7.36405 0.288886C7.34778 0.291635 7.33153 0.294426 7.31529 0.297277C7.30646 0.298822 7.29765 0.300421 7.28883 0.301997C7.2807 0.303453 7.27257 0.304893 7.26445 0.306366C7.25481 0.308125 7.24519 0.309914 7.23557 0.311708C7.22816 0.313081 7.22076 0.314459 7.21335 0.315857C7.20385 0.317655 7.19437 0.319469 7.18489 0.321297C7.17733 0.322754 7.16977 0.324224 7.1622 0.3257C7.15255 0.327595 7.1429 0.329496 7.13326 0.331421C7.12633 0.332807 7.11942 0.334204 7.11249 0.335602C7.10224 0.337684 7.09199 0.339764 7.08174 0.341882C7.07589 0.343089 7.07002 0.344322 7.06418 0.345542C7.05301 0.347881 7.04183 0.350215 7.03065 0.352597C7.02772 0.353226 7.02479 0.353873 7.02187 0.354502C7.00077 0.359032 6.97971 0.363639 6.95869 0.368337C6.93767 0.373034 6.91667 0.377815 6.89572 0.382679C6.89258 0.383402 6.88943 0.384128 6.88628 0.384859C6.87371 0.387792 6.86117 0.390767 6.84862 0.393762C6.84484 0.394662 6.84107 0.395556 6.83729 0.396461C6.82463 0.399508 6.81196 0.402584 6.79931 0.405683C6.79595 0.40651 6.7926 0.407335 6.78925 0.408161C6.77603 0.411419 6.76285 0.414706 6.74967 0.418028C6.74745 0.418586 6.74523 0.419149 6.74303 0.419711C6.72874 0.423326 6.71447 0.427 6.70022 0.430691C6.69509 0.432024 6.68997 0.433367 6.68484 0.434699C6.67522 0.437217 6.66559 0.439749 6.65599 0.442296C6.65064 0.443719 6.6453 0.445135 6.63995 0.446568C6.62835 0.44967 6.61676 0.452801 6.60519 0.455956C6.60048 0.457244 6.59576 0.458527 6.59104 0.459823C6.5795 0.462992 6.56797 0.466187 6.55645 0.469406C6.54994 0.471221 6.54345 0.473052 6.53695 0.474892C6.52949 0.476992 6.52203 0.479117 6.51457 0.481241C6.50751 0.483257 6.50046 0.485272 6.4934 0.487305C6.48593 0.489461 6.47844 0.491643 6.47096 0.493826C6.45851 0.497457 6.44606 0.501118 6.43362 0.504809C6.42727 0.506698 6.42093 0.508575 6.41458 0.510482C6.4061 0.51302 6.39765 0.515581 6.38917 0.518156C6.38425 0.519644 6.37934 0.521138 6.37442 0.522645C6.36547 0.525377 6.35651 0.528122 6.34756 0.530893C6.3439 0.532023 6.34024 0.533166 6.33659 0.534309C6.31687 0.540436 6.2972 0.546635 6.27757 0.552916C6.27619 0.55335 6.27483 0.553782 6.27346 0.554215C6.26361 0.55737 6.25375 0.560558 6.24391 0.563754C6.2405 0.564855 6.2371 0.565959 6.2337 0.567072C6.22342 0.570425 6.21315 0.573789 6.20289 0.577184L6.20255 0.577295C4.86488 1.01962 3.67179 1.81035 2.69792 2.85165L5.10445 2.67288Z"
          fill="#EAA83C"
        />
        <path
          d="M5.69193 4.86284C5.34328 5.34879 5.04586 5.88221 4.80789 6.45243C4.30796 7.65035 4.07036 9.01056 4.17125 10.4336C4.48051 14.796 7.85379 18.1039 11.7177 17.8469C11.7529 17.841 11.788 17.8348 11.8231 17.8284C8.09347 17.8903 4.89411 14.645 4.59333 10.4023C4.49244 8.97921 4.73008 7.619 5.23006 6.42107C5.46804 5.85086 5.76545 5.31741 6.11412 4.83147C6.91313 3.71787 7.98119 2.85373 9.21949 2.36807C9.69082 2.18322 10.1868 2.05322 10.702 1.98516C10.6668 1.98396 10.6316 1.98303 10.5963 1.98242C9.96701 2.03373 9.36402 2.17691 8.79675 2.39947C7.55865 2.88526 6.49079 3.74937 5.69193 4.86284Z"
          fill="#FFED00"
        />
        <path
          d="M15.1851 3.37927C14.4183 2.77844 13.5461 2.34272 12.6125 2.11473C11.9782 1.95983 11.3154 1.90081 10.6381 1.95113C10.5359 1.95872 10.4345 1.96858 10.3338 1.9813C10.3311 1.98165 10.3283 1.98198 10.3255 1.98233L10.3257 1.98233C10.4155 1.98008 10.5049 1.97975 10.594 1.9813C10.6293 1.9819 10.6645 1.98284 10.6997 1.98403C11.1382 1.99896 11.5683 2.05931 11.9861 2.16126C13.2591 2.47196 14.4178 3.16898 15.3512 4.144C15.7627 4.57394 16.1305 5.05792 16.445 5.58667C16.7088 6.03039 16.9351 6.50564 17.1183 7.00691C17.3943 7.7625 17.5723 8.57722 17.6329 9.43232C17.6936 10.2875 17.6323 11.1201 17.4657 11.9087C16.8265 14.9332 14.6362 17.3094 11.8208 17.8273C11.7858 17.8337 11.7506 17.8399 11.7154 17.8458C11.6284 17.8603 11.5409 17.873 11.4528 17.8839C11.4776 17.8834 11.5025 17.8826 11.5274 17.8818C11.5363 17.8814 11.5452 17.8811 11.5541 17.8808C11.5635 17.8804 11.5728 17.88 11.5821 17.8796L11.5867 17.8794C11.6009 17.8787 11.615 17.878 11.6292 17.8773C11.6295 17.8773 11.6297 17.8772 11.6299 17.8772C11.6444 17.8765 11.6588 17.8757 11.6733 17.8748C11.6743 17.8747 11.6753 17.8747 11.6763 17.8746C11.6895 17.8738 11.7028 17.873 11.716 17.8721C11.7181 17.8719 11.7202 17.8718 11.7224 17.8717C11.7369 17.8707 11.7514 17.8697 11.766 17.8686L11.7665 17.8686C13.441 17.7442 14.9326 16.9721 16.0646 15.7833C17.5674 14.2053 18.4366 11.8927 18.2589 9.38582C18.0811 6.87882 16.8948 4.71882 15.1851 3.37927Z"
          fill="#E6913A"
        />
        <path
          d="M15.5192 10.158C15.5192 13.3557 13.6465 15.4243 11.3286 15.4243C8.73729 15.4243 6.77864 12.9315 6.77864 9.92965C6.77864 6.92781 8.74234 4.40234 11.2729 4.40234C12.3104 4.42192 13.5099 4.98966 14.183 5.79232L12.9835 7.91319C12.528 7.36503 11.8752 7.01264 11.2729 7.01264C10.0582 7.01264 8.99034 8.29821 8.99034 9.92312C8.99034 11.3979 9.90639 12.8336 11.4146 12.8336C12.4015 12.8336 13.105 12.2202 13.1354 11.2152H11.2678V9.1335H15.4534C15.4938 9.48589 15.5192 9.82523 15.5192 10.158Z"
          fill="#E6913A"
        />
        <path
          d="M9.09426 9.92307C9.09426 8.35348 10.0905 7.10064 11.2531 7.01714C11.2218 7.01413 11.1908 7.01257 11.1602 7.01257C9.94555 7.01257 8.87761 8.29815 8.87761 9.92307C8.87761 11.3979 9.79371 12.8336 11.3019 12.8336C11.3384 12.8336 11.3744 12.8327 11.41 12.831C9.96643 12.7641 9.09426 11.3622 9.09426 9.92307ZM11.3767 4.40234C11.329 4.40234 11.2816 4.40323 11.2343 4.40502C12.2551 4.45957 13.5017 5.23434 14.1608 6.01524L14.2869 5.79235C13.6138 4.98963 12.4142 4.42194 11.3767 4.40234ZM15.5572 9.13349H15.3406C15.3812 9.48586 15.4064 9.82521 15.4064 10.158C15.4064 13.3066 13.5907 15.3607 11.322 15.4228C11.3587 15.4238 11.3955 15.4243 11.4324 15.4243C13.7504 15.4243 15.623 13.3556 15.623 10.158C15.623 9.82521 15.5977 9.48586 15.5572 9.13349Z"
          fill="#FFED00"
        />
        <path
          d="M12.8767 8.14913L14.0875 5.9888C14.0849 5.98569 14.0823 5.98257 14.0795 5.97945L12.9849 7.91522C12.5293 7.36701 11.8765 7.01464 11.2741 7.01464C11.2067 7.01464 11.1398 7.01864 11.0735 7.02633C11.6666 7.11105 12.4588 7.64612 12.8767 8.14913ZM11.2377 12.8288C11.2961 12.8333 11.3555 12.8356 11.4158 12.8356C12.4028 12.8356 13.1062 12.2222 13.1367 11.2172H12.7811C12.7526 12.1609 12.1306 12.7594 11.2377 12.8288ZM10.9137 11.2172H11.2691V9.13544H10.9137V11.2172ZM6.77986 9.93159C6.77986 7.01775 8.63023 4.55259 11.0532 4.41075C11.0077 4.4073 10.9629 4.40508 10.9187 4.4043C8.38813 4.4043 6.42442 6.9298 6.42442 9.93159C6.42442 12.9334 8.38312 15.4264 10.9744 15.4264C11.0331 15.4264 11.0915 15.425 11.1497 15.4223C8.64829 15.3099 6.77986 12.8635 6.77986 9.93159Z"
          fill="#EAA83C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1482_16632">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function SweepCoin() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <g clipPath="url(#clip0_1500_22716)">
        <path
          d="M14.1246 1.25252L11.6979 0.792068C11.68 0.788671 11.6621 0.785347
        11.6442 0.782072C11.638 0.78095 11.6319 0.779864 11.6258 0.778756C11.614 0.776642
        11.6023 0.77453 11.5905 0.772461C11.5832 0.771174 11.5758 0.769904 11.5684 0.768628C11.5578
        0.766795 11.5473 0.76497 11.5367 0.763185C11.5291 0.761912 11.5216 0.760644 11.514 0.759397C11.5032
        0.757603 11.4924 0.755827 11.4816 0.754085C11.4745 0.752926 11.4673 0.751771 11.4602 0.750633C11.449 0.748854 11.4378 0.747121 11.4267 0.745395C11.4197 0.744313 11.4127 0.74322 11.4058 0.742158C11.3934 0.740285 11.3811 0.738452 11.3688 0.736638C11.3632 0.735821 11.3577 0.73498 11.3521 0.734168C11.3344 0.73159 11.3166 0.729062 11.2988 0.726606C11.2946 0.726015 11.2903 0.725459 11.286 0.724871C11.2724 0.723017 11.2588 0.721171 11.2453 0.719379C11.238 0.718412 11.2306 0.717492 11.2233
        0.716551C11.2129 0.715204 11.2025 0.713874 11.1921 0.712572C11.1838 0.711529 11.1755 0.710524 11.1672 0.709509C11.1577 0.708355 11.1482 0.707205 11.1387 0.70609C11.1301 0.705068 11.1214 0.704066 11.1128 0.703071C11.1037 0.70203 11.0947 0.701007 11.0856 0.7C11.0766 0.698994 11.0676 0.697995 11.0586 0.697027C11.0496 0.696052 11.0406 0.695108 11.0316 0.694169C11.023 0.69326 11.0143 0.692344 11.0056 0.691471C10.9958 0.690468 10.9859 0.68951 10.976 0.68855C10.9679 0.687765 10.9599 0.686946 10.9518 0.686184C10.935 0.684595 10.9182 0.683055 10.9013 0.681577C10.8922 0.680769 10.8831 0.680018 10.8739 0.679243C10.8655 0.678532 10.8571 0.677803 10.8487 0.677113C10.8387 0.676301 10.8287 0.675524 10.8187 0.674752C10.811 0.67415 10.8033 0.673553 10.7956 0.672975C10.7858 0.672239 10.7759 0.671526 10.7661 0.670824C10.7582
        0.670264 10.7503 0.669717 10.7425 0.669176C10.7324 0.668496 10.7224 0.667822 10.7124 0.667175C10.7051 0.666712 10.6979 0.666264 10.6907 0.665815C10.68 0.66516 10.6693 0.664504 10.6586 0.663886C10.6525 0.663532 10.6464 0.663201 10.6403 0.662862C10.6287 0.662218 10.617 0.661568 10.6053 0.660967C10.6022 0.660815 10.5992 0.660679 10.5961 0.660526C10.5741 0.659426 10.552 0.658411 10.53 0.657495C10.508 0.656577 10.4859 0.65575 10.4639 0.655016C10.4606 0.654902 10.4573 0.654786 10.454 0.654675C10.4408 0.654252 10.4276 0.653875 10.4144 0.653517C10.4105 0.653408 10.4065 0.653293 10.4025 0.65319C10.3892
         0.652852 10.3759 0.652544 10.3625 0.652262C10.359 0.652191 10.3555 0.65212 10.3519 0.65205C10.338 0.651777 10.3241 0.65154 10.3102 0.651338C10.3079 0.651304 10.3055 0.651274 10.3032 0.651247C10.2881 0.651042 10.273 0.6509 10.258 0.650779C10.2525 0.650741 10.2471 0.650715 10.2417 0.650675C10.2315 0.650621 10.2213 0.650579 10.2112 0.650557C10.2055 0.65055 10.1998 0.650536 10.1942 0.65054C10.1819 0.650538 10.1696 0.65057 10.1573 0.650629C10.1523 0.650657 10.1473 0.650677 10.1423 0.650711C10.1301 0.650792 10.1178 0.650902 10.1056 0.651037C10.0987 0.651112 10.0917 0.651205 10.0848 0.651306C10.0769 0.651409 10.069 0.651537 10.061 0.651665C10.0535 0.651793 10.046 0.651919 10.0385 0.652063C10.0305 0.65222 10.0226 0.652398 10.0146 0.652578C10.0013 0.652875 9.98804 0.653203 9.97476 0.653565C9.96798 0.653753 9.96121 0.653931 9.95443 0.654137C9.94538 0.654406 9.93634 0.654702 9.92728 0.655007C9.92203 0.655178 9.91677 0.655356 9.91151 0.655546C9.90193 0.65588 9.89235 0.656226 9.88277 0.656598C9.87885 0.656749 9.87493 0.65691 9.87101 0.657075C9.8499 0.657927 9.82881 0.658849 9.80774 0.659868C9.80626 0.659933 9.8048 0.66 9.80334 0.660068C9.79275 0.660581 9.78216 0.661126 9.77159 0.661686C9.76793 0.661874 9.76428 0.662068 9.76062 0.662268C9.74957 0.662864 9.73853 0.663476 9.72748 0.66412L9.72712 0.664141C9.71308 0.664957 9.69905 0.665825 9.68502 0.666713C9.68018 0.667014 9.67535 0.667329 9.67052 0.667646C9.66018 0.668316 9.64985 0.669012 9.63953
          0.669727C9.6353 0.670016 9.63107 0.670295 9.62688 0.670596C9.61408 0.671494 9.60129 0.672431 9.58851 0.673397C9.58233 0.673866 9.57616 0.674343 9.56998 0.674824C9.56181 0.675457 9.55365 0.676111 9.54547 0.676768C9.53918 0.677281 9.5329 0.67778 9.52661 0.678305C9.51478 0.679284 9.50294 0.680287 9.49113 0.681322C9.48333 0.682 9.47555 0.682713 9.46775 0.683417C9.46205 0.683932 9.45637 0.684451 9.45069 0.684975C9.44259 0.685724 9.4345 0.686475 9.42641 0.687251C9.42163 0.687704 9.41686 0.688184 9.41207 0.688642C9.39624 0.690189 9.38039 0.691775 9.36457 0.693408C9.36113 0.693764 9.35768
          0.694117 9.35423 0.694471C9.34442 0.695502 9.3346 0.696538 9.3248 0.697603C9.32336 0.697765 9.32192 0.697919 9.32047 0.698077C9.30193 0.70009 9.28342 0.702189 9.26491 0.704328C9.26008 0.704887 9.25525 0.705463 9.25043 0.706031C9.23597 0.707731 9.22151 0.709463 9.20707 0.711236C9.20272 0.711772 9.19836 0.712305 9.19401 0.712844C9.15573 0.717617 9.11748 0.722644 9.07931 0.727947C9.07823 0.728099 9.07715 0.728253 9.07607 0.728405C9.05787 0.730936 9.03969 0.733538 9.02153 0.736197C9.01927 0.736527 9.01701 0.736852 9.01477 0.737186C5.15824 1.30405 1.7959 4.60275 0.927005 9.09283C-0.0113414 13.9418 2.27104 18.5643 6.1588 20.2357C6.16162 20.2369 6.16442 20.2381 6.16724 20.2393C6.1832 20.2461 6.19919 20.2529 6.21521 20.2597C6.21865 20.2611 6.22208 20.2626 6.22553 20.264C6.24419 20.2718 6.26288 20.2796 6.28162 20.2873C6.28207 20.2875 6.28252 20.2877 6.28296 20.2879C6.29324 20.2921 6.30352 20.2963 6.31384 20.3005C6.3153 20.301 6.31677 20.3016 6.31823 20.3022C6.33445 20.3088

          6.35071 20.3153 6.367 20.3218C6.37277 20.3241 6.37854 20.3264 6.38431 20.3286C6.39142 20.3314 6.39852 20.3342 6.40563 20.337C6.41499 20.3407 6.42435 20.3443 6.43373 20.3479C6.44045 20.3505 6.44719 20.3531 6.45392 20.3557C6.46404 20.3596 6.47417 20.3635 6.48431 20.3673C6.48915 20.3691 6.494 20.371 6.49885 20.3728C6.51263 20.378 6.5264 20.3832 6.54022 20.3883L6.54297 20.3893C6.55353 20.3932 6.5641 20.3971 6.57466 20.401C6.57781 20.4021 6.58094 20.4032 6.58408 20.4044C6.6019 20.4109 6.61975 20.4173 6.63765 20.4237C6.64138 20.425 6.64513 20.4263 6.64887 20.4277C6.6573 20.4307 6.66574 20.4336 6.67418 20.4366C6.68077 20.4389 6.68739 20.4412 6.69399 20.4435C6.70129 20.446 6.70858 20.4486 6.71589 20.4511C6.72891 20.4556 6.74195 20.46 6.75501 20.4644C6.76033 20.4662 6.76567 20.468 6.77101 20.4698C6.78073 20.4731 6.79046 20.4763 6.80022 20.4796C6.80554 20.4813 6.81088 20.4831 6.81622 20.4849C6.8308 20.4897 6.8454 20.4945 6.86002 20.4992C6.86088 20.4995 6.86174 20.4997 6.8626 20.5C6.87636 20.5045 6.89014 20.5089 6.90396 20.5132L6.90591 20.5139C6.9463 20.5266 6.98683 20.5391 7.02749 20.5513C7.03077 20.5523 7.03405 20.5533 7.03731 20.5542C7.04851 20.5576 7.05974 20.5609 7.07096 20.5642C7.0761 20.5657 7.08124 20.5672 7.08638 20.5687C7.09708 20.5718 7.10781 20.5749 7.11853 20.5779C7.12372 20.5794 7.12891 20.5809 7.13412 20.5824C7.15572 20.5885 7.17738 20.5946 7.19908 20.6005C7.20279 20.6016 7.20649 20.6026 7.2102 20.6036C7.21935 20.6061 7.22853 20.6086 7.23771 20.6111C7.24538 20.6131 7.25306 20.6152 7.26074 20.6173C7.26945 20.6196 7.27817 20.6219 7.2869 20.6242C7.2952 20.6264 7.30351 20.6285 7.31184 20.6307C7.32001 20.6328 7.32822 20.6349 7.33642 20.637C7.34653 20.6396 7.35665 20.6422 7.36679 20.6447C7.37443 20.6467 7.38205 20.6486 7.3897 20.6505C7.40465 20.6542 7.41961 20.6579 7.43461 20.6615C7.44099 20.6631 7.44739 20.6646 7.45379 20.6662C7.46464 20.6688 7.47549 20.6714 7.48635 20.6739C7.4932 20.6755 7.50006 20.6771 7.5069 20.6787C7.51748 20.6812 7.52809 20.6836 7.53869 20.6861C7.54534 20.6876 7.55201 20.6891 7.55868 20.6906C7.57265 20.6938 7.58666 20.6969 7.60067 20.7C7.60366 20.7007 7.60665 20.7014 7.60966 20.702C7.62651 20.7057 7.64339 20.7093 7.66029 20.7129C7.666 20.7142 7.67172 20.7153 7.67746 20.7165C7.68927 20.719 7.70111 20.7215 7.71295 20.7239C7.71906 20.7252 7.72517 20.7265 7.73129 20.7277C7.74343 20.7302 7.75561 20.7326 7.76779 20.735C7.77316 20.7361 7.77853 20.7372 7.78392 20.7382C7.80128 20.7416 7.81867 20.745 7.83609 20.7483L10.2628
          21.2088C15.1449 22.1352 19.9673 18.4188 21.0337 12.908C22.1001 7.39726 19.0068 2.17891 14.1246 1.25252Z"
          fill="#32DA30"
        />

        <path
          d="M19.3086 12.5825C18.8191 15.112 17.3463 17.1718 15.4422 18.3364C14.0076 19.2138 12.3284 19.5832 10.6402 19.2629L10.6396 19.2628C10.625 19.26 10.6103 19.2571 10.5957 19.2543C10.5936 19.2539 10.5915 19.2534 10.5894 19.253C10.5761 19.2504 10.5627 19.2477 10.5494 19.245C10.5484 19.2449 10.5474 19.2445 10.5464 19.2443C10.5319 19.2415 10.5174 19.2383 10.5029 19.2353L10.5022 19.2352C10.488 19.2321 10.4737 19.229 10.4596 19.226C10.458 19.2257 10.4565 19.2252 10.455 19.225C10.4456 19.2229 10.4363 19.2208 10.4271 19.2188C10.4182 19.2167 10.4092 19.2147 10.4004 19.2127C10.3755 19.2069 10.3508 19.2011 10.3261 19.195C10.416 19.2074 10.5059 19.2181 10.5957 19.2268C6.70807 18.4579 4.25137 14.2888 5.10317 9.88704C5.38105 8.4511 5.9768 7.16711 6.78882 6.11318C7.17534 5.61164 7.61098 5.16216 8.08455 4.77324C9.16959 3.88221 10.4545 3.30938 11.8072 3.15625C12.427 3.08612 13.061 3.10403 13.6966 3.21991C13.609 3.19483 13.5205 3.17139 13.4313 3.14985C13.4339 3.15022 13.4368 3.15064 13.4396 3.15103C13.5424 3.16504 13.6452 3.18212 13.7482 3.20167C14.4311 3.33125 15.0706 3.56532 15.6565 3.88664C16.5189 4.35975 17.2654 5.02214 17.864 5.82029C19.1986 7.59957 19.7981 10.0528 19.3086 12.5825Z"
          fill="#1EC61C"
        />
        <path
          d="M3.35369 9.55318C3.62511 8.15058 4.13985 6.86424 4.83696 5.74108C5.14539 5.24415 5.4895 4.77915 5.86405 4.35018C6.52059 3.59827 7.27059 2.95705 8.08564 2.44835C9.88378 1.32608 11.9985 0.849003 14.1246 1.25242L11.6979 0.791969C11.68 0.788572 11.6621 0.785248 11.6442 0.781972C11.638 0.780851 11.6319 0.779765 11.6258 0.778657C11.614 0.776544 11.6023 0.774431 11.5906 0.772362C11.5832 0.771075 11.5758 0.769806 11.5685 0.768529C11.5579 0.766696 11.5473 0.764871 11.5367
        0.763086C11.5291 0.761813 11.5216 0.760545 11.514 0.759298C11.5032 0.757505 11.4924 0.755728 11.4816 0.753986C11.4745 0.752827 11.4673 0.751673 11.4602 0.750534C11.449 0.748756 11.4379 0.747022 11.4267 0.745296C11.4197 0.744214 11.4128 0.743122 11.4058 0.742059C11.3934 0.740186 11.3811 0.738353 11.3688 0.736539C11.3632 0.735722 11.3577 0.734882 11.3521 0.734069C11.3344 0.731491 11.3166 0.728963 11.2988 0.726507C11.2946 0.725916 11.2903 0.72536 11.286 0.724773C11.2725 0.722918 11.2589 0.721072 11.2453 0.71928C11.238 0.718313 11.2307 0.717393 11.2233 0.716452C11.2129 0.715105 11.2025 0.713775 11.1921 0.712473C11.1838 0.71143 11.1755 0.710425 11.1672 0.70941C11.1577 0.708256 11.1482 0.707106 11.1387 0.705991C11.1301 0.704969 11.1214 0.703967 11.1128 0.702972C11.1037 0.701931
        11.0947 0.700908 11.0856 0.699901C11.0766 0.698895 11.0676 0.697896 11.0586 0.696928C11.0496 0.695953 11.0406 0.695009 11.0316 0.69407C11.023 0.693161 11.0143 0.692245 11.0057 0.691372C10.9958 0.690369 10.9859 0.689411 10.976 0.688452C10.968 0.687666 10.9599 0.686847 10.9518 0.686085C10.935 0.684496 10.9182 0.682956 10.9014 0.681478C10.8922 0.68067 10.8831 0.679919 10.874 0.679145C10.8655 0.678433 10.8571 0.677704 10.8487 0.677014C10.8387 0.676202 10.8287 0.675425 10.8187 0.674653C10.811 0.674051 10.8034 0.673454 10.7957 0.672876C10.7858 0.67214 10.7759 0.671427 10.7661 0.670725C10.7582 0.670165 10.7504 0.669618 10.7425 0.669077C10.7325 0.668397 10.7224 0.667723 10.7124 0.667076C10.7051 0.666613 10.6979 0.666165 10.6907 0.665715C10.68 0.66506 10.6694 0.664405 10.6587 0.663787C10.6526 0.663433 10.6464 0.663102 10.6403 0.662763C10.6287 0.662119 10.617 0.661469 10.6053 0.660868C10.6023 0.660716 10.5992 0.66058 10.5961 0.660427C10.5741 0.659327 10.552 0.658312 10.53 0.657396C10.508 0.656478 10.486 0.655651 10.464 0.654917C10.4607 0.654803 10.4574 0.654687 10.4541 0.654577C10.4409 0.654153 10.4277 0.653777 10.4145 0.653418C10.4105 0.653309 10.4065 0.653194 10.4026 0.653092C10.3892 0.652753 10.3759 0.652445 10.3626 0.652163C10.359 0.652092 10.3555 0.652021 10.352 0.651951C10.338 0.651678 10.3241 0.651441 10.3102 0.651239C10.3079 0.651205 10.3055
        0.651175 10.3032 0.651148C10.2881 0.650943 10.273 0.650801 10.258 0.65068C10.2525 0.650642 10.2471 0.650615 10.2417 0.650576C10.2315 0.650522 10.2213 0.65048 10.2112 0.650458C10.2055 0.650451 10.1998 0.650437 10.1942 0.650441C10.1819 0.65044 10.1696 0.650471 10.1573 0.65053C10.1523 0.650558 10.1473 0.650578 10.1423 0.650612C10.1301 0.650693 10.1178 0.650803 10.1056 0.650938C10.0987 0.651013 10.0918 0.651106 10.0849 0.651207C10.0769 0.65131 10.069 0.651438 10.061 0.651566C10.0535 0.651694 10.046 0.65182 10.0385 0.651964C10.0306 0.652121 10.0226 0.652299 10.0146 0.652479C10.0013 0.652776 9.98805 0.653104 9.97478 0.653466C9.968 0.653654 9.96123 0.653831 9.95445 0.654038C9.9454 0.654307 9.93636 0.654603 9.9273 0.654908C9.92204 0.655079 9.91679 0.655257 9.91153 0.655447C9.90195 0.655781 9.89237 0.656127 9.88278 0.656499C9.87887 0.65665 9.87494 0.656811 9.87103 0.656976C9.84992 0.657828 9.82883 0.65875 9.80775 0.659768C9.80627 0.659834 9.80481 0.659901 9.80335 0.659969C9.79277 0.660482 9.78218 0.661027 9.77161 0.661587C9.76795 0.661775 9.7643 0.661969 9.76064 0.662169C9.74958 0.662765 9.73854 0.663377 9.72749 0.66402L9.72713 0.664042C9.71309 0.664858 9.69906 0.665726 9.68504 0.666614C9.6802 0.666915 9.67536 0.66723 9.67053 0.667546C9.6602 0.668217 9.64987 0.668913 9.63955 0.669628C9.63531 0.669917 9.63109 0.670196 9.62689 0.670497C9.61409 0.671395 9.6013 0.672332 9.58853 0.673298C9.58234 0.673767 9.57617 0.674244 9.57 0.674725C9.56183 0.675358 9.55366 0.676012 9.54549 0.676669C9.5392 0.677182 9.53291 0.677681 9.52663 0.678206C9.5148 0.679185 9.50296 0.680188 9.49114 0.681223C9.48335 0.681901 9.47556 0.682613 9.46776 0.683318C9.46207 0.683833 9.45639 0.684352 9.45071 0.684876C9.44261 0.685625 9.43452 0.686376 9.42643 0.687152C9.42165 0.687604 9.41687 0.688085 9.41209 0.688543C9.39625 0.69009 9.38041 0.691675 9.36459 0.693309C9.36115 0.693665 9.35769 0.694018 9.35424 0.694372C9.34443 0.695403 9.33462 0.696439 9.32482 0.697504C9.32338 0.697666 9.32194 0.69782 9.32048 0.697978C9.30195 0.699991 9.28343 0.70209 9.26493 0.704229C9.2601 0.704788 9.25526 0.705364 9.25045 0.705932C9.23599 0.707632 9.22153 0.709364 9.20708 0.711137C9.20274 0.711672 9.19838 0.712206
        9.19402 0.712745C9.15574 0.717518 9.1175 0.722544 9.07932 0.727848C9.07824 0.728 9.07717 0.728154 9.07609 0.728306C9.05789 0.730837 9.03971 0.733439 9.02155 0.736097C9.01929 0.736428 9.01703 0.736753 9.01478 0.737087C5.15825 1.30395 1.79591 4.60265 0.927022 9.09273C-0.011325 13.9417 2.27106 18.5642 6.15882 20.2356C6.16164 20.2368 6.16444 20.238 6.16726 20.2392C6.18321 20.246 6.1992 20.2528 6.21523 20.2596C6.21867 20.261 6.2221 20.2625 6.22555 20.2639C6.24421 20.2717 6.26289 20.2795 6.28164 20.2872C6.28209 20.2874 6.28253 20.2876 6.28298 20.2878C6.29326 20.292 6.30354 20.2962 6.31386 20.3004C6.31531 20.3009 6.31679 20.3015 6.31825 20.3021C6.33447 20.3087 6.35073 20.3152 6.36702 20.3217C6.37278 20.324 6.37856 20.3263 6.38433 20.3285C6.39144 20.3313 6.39853 20.3341 6.40565 20.3369C6.41501 20.3406 6.42437 20.3442 6.43375 20.3478C6.44047 20.3504 6.4472 20.353 6.45394 20.3556C6.46406 20.3595 6.47419 20.3634 6.48433 20.3672C6.48917 20.369 6.49402 20.3709 6.49887 20.3727C6.51265 20.3779 6.52642 20.3831 6.54024 20.3882L6.54299 20.3892C6.55355 20.3931 6.56412 20.397 6.57468 20.4009C6.57783 20.402 6.58096 20.4031 6.5841 20.4043C6.60192 20.4108 6.61977 20.4172 6.63767 20.4236C6.6414 20.4249 6.64515 20.4262 6.64888 20.4276C6.65732 20.4305 6.66575 20.4335 6.6742 20.4365C6.68079 20.4388 6.68741
        20.4411 6.69401 20.4434C6.7013 20.4459 6.7086 20.4485 6.7159 20.451C6.72893 20.4555 6.74197 20.4599 6.75502 20.4643C6.76035 20.4661 6.76569 20.4679 6.77103 20.4697C6.78075 20.473 6.79048 20.4762 6.80024 20.4795C6.80556 20.4812 6.8109 20.483 6.81624 20.4848C6.83082 20.4896 6.84542 20.4943 6.86004 20.4991C6.8609 20.4993 6.86176 20.4996 6.86262 20.4999C6.87638 20.5044 6.89016 20.5088 6.90398 20.5131L6.90593 20.5138C6.94631 20.5265 6.98685 20.539 7.02751 20.5512C7.03079 20.5522 7.03406 20.5532 7.03733 20.5541C7.04853 20.5575 7.05976 20.5608 7.07098 20.564C7.07612 20.5656 7.08125 20.5671 7.08639 20.5686C7.0971 20.5717 7.10782 20.5748 7.11855 20.5778C7.12374 20.5793 7.12893 20.5808 7.13413 20.5823C7.15574 20.5884 7.1774 20.5945 7.1991 20.6004C7.20281 20.6015 7.20651 20.6025 7.21022 20.6035C7.21937 20.606 7.22855 20.6085 7.23773 20.611C7.2454 20.613 7.25308 20.6151 7.26076 20.6172C7.26947 20.6195 7.27819 20.6218 7.28691 20.6241C7.29522 20.6263 7.30353 20.6284 7.31186 20.6306C7.32003 20.6327 7.32824 20.6348 7.33644 20.6369C7.34654 20.6395 7.35667 20.6421 7.36681 20.6446C7.37444 20.6466 7.38207 20.6485 7.38972 20.6504C7.40466 20.6541 7.41963 20.6578 7.43462 20.6614C7.441 20.663 7.44741 20.6645 7.45381 20.6661C7.46466 20.6687 7.47551 20.6713 7.48637 20.6738C7.49322 20.6754 7.50007 20.677 7.50692 20.6786C7.5175 20.6811 7.52811 20.6835 7.53871 20.686C7.54536 20.6875 7.55203 20.689 7.55869 20.6905C7.57266 20.6937 7.58667 20.6968 7.60069 20.6999C7.60368 20.7006 7.60667 20.7012 7.60968 20.7019C7.62653 20.7056 7.64341 20.7092 7.66031 20.7128C7.66602 20.7141 7.67174 20.7152 7.67748 20.7164C7.68929 20.7189 7.70113 20.7214 7.71297 20.7238C7.71908 20.7251 7.72519 20.7263 7.73131 20.7276C7.74345 20.7301 7.75563 20.7325 7.76781 20.7349C7.77318 20.736 7.77855 20.7371 7.78394 20.7381C7.8013 20.7415 7.81869 20.7449 7.83611 20.7482L10.2628 21.2087C8.32181 20.8404 6.6636 19.7937 5.4371 18.32C3.57851 16.0868 2.71124 12.8731 3.35369 9.55318Z"
          fill="#008A00"
        />
        <path
          d="M3.01142 17.8625C3.95499 18.996 5.15371 19.8771 6.54021 20.391L6.54296 20.392C6.55352 20.3959 6.56409 20.3998 6.57465 20.4036C6.5778 20.4048 6.58092 20.4059 6.58407 20.4071C6.60189 20.4136 6.61974 20.42 6.63764 20.4264C6.64137 20.4277 6.64512 20.429 6.64885 20.4304C6.65729 20.4333 6.66572 20.4363 6.67417 20.4393C6.68076 20.4416 6.68738 20.4439 6.69397 20.4462C6.70127 20.4487 6.70857 20.4512 6.71587 20.4538C6.7289 20.4582 6.74194 20.4627 6.75499 20.4671C6.76032 20.4689 6.76565 20.4707 6.771 20.4725C6.78072 20.4758 6.79045 20.479 6.80021 20.4823C6.80553 20.484 6.81087 20.4858 6.81621 20.4876C6.83079 20.4924 6.84539 20.4971 6.86001 20.5019C6.86086 20.5021 6.86172 20.5024 6.86258 20.5027C6.87634 20.5071 6.89013 20.5116 6.90395 20.5159L6.9059 20.5165C6.94628 20.5293 6.98681 20.5418 7.02748 20.554C7.03076 20.5549 7.03403 20.5559 7.0373 20.5569C7.0485 20.5603 7.05972 20.5635 7.07095 20.5668C7.07609 20.5683 7.08122 20.5698 7.08636 20.5713C7.09707 20.5745 7.10779 20.5776 7.11852 20.5806C7.12371 20.5821 7.1289 20.5836 7.1341 20.5851C7.15571 20.5912 7.17737 20.5973 7.19907 20.6032C7.20278 20.6043 7.20647 20.6053 7.21019 20.6063C7.21934 20.6088 7.22852 20.6113 7.2377 20.6138C7.24537 20.6158 7.25305 20.6179 7.26073 20.6199C7.26943 20.6223 7.27816 20.6246 7.28688 20.6269C7.29519 20.629 7.3035 20.6312 7.31183 20.6334C7.32 20.6355 7.32821 20.6376 7.33641 20.6397C7.34651 20.6423 7.35663 20.6449 7.36677 20.6474C7.37441 20.6494 7.38204 20.6513 7.38969 20.6532C7.40463 20.6569 7.41959 20.6606 7.43459 20.6642C7.44097 20.6658 7.44738 20.6673 7.45378 20.6688C7.46462 20.6715 7.47548 20.674 7.48633 20.6766C7.49319 20.6782 7.50004 20.6798 7.50689 20.6814C7.51747 20.6839 7.52807 20.6863 7.53868 20.6888C7.54533 20.6903 7.552 20.6918 7.55866 20.6933C7.57263 20.6965 7.58664 20.6996 7.60066 20.7027C7.60365 20.7034 7.60664 20.704 7.60965 20.7047C7.6265 20.7084 7.64338 20.712 7.66027 20.7156C7.66599 20.7168 7.67171 20.718 7.67745 20.7192C7.68926 20.7217 7.7011 20.7242 7.71294 20.7266C7.71905 20.7279 7.72516 20.7291 7.73128 20.7304C7.74342 20.7329 7.7556 20.7353 7.76778 20.7377C7.77315 20.7388 7.77852 20.7399 7.78391 20.7409C7.80127 20.7443 7.81866 20.7477 7.83608 20.751L10.2627 21.2115C8.32178 20.8432 6.66357 19.7965 5.43707 18.3228L3.01142 17.8625Z"
          fill="#003A00"
        />
        <path
          d="M2.41017 5.28229L4.83609 5.7426C5.14452 5.24567 5.48863 4.78067 5.86318 4.35169L3.43729 3.89139C3.06271 4.32035 2.71868 4.78542 2.41017 5.28229Z"
          fill="#005800"
        />
        <path
          d="M8.08752 2.44655C9.88566 1.32428 12.0004 0.847202 14.1265 1.25062L11.6998 0.790168C11.6819 0.786771 11.664 0.783447 11.6461 0.780171C11.6399 0.77905 11.6338 0.777963 11.6277 0.776856C11.6159 0.774742 11.6042 0.77263 11.5924 0.770561C11.5851 0.769274 11.5777 0.768004 11.5703 0.766728C11.5597 0.764895 11.5491 0.76307 11.5386 0.761285C11.531 0.760012 11.5235 0.758744 11.5159 0.757497C11.5051 0.755703 11.4943 0.753927 11.4835 0.752185C11.4764 0.751026 11.4692 0.749871 11.462 0.748733C11.4509 0.746954 11.4397 0.745221 11.4286 0.743495C11.4216 0.742413 11.4146 0.74132 11.4077 0.740258C11.3953 0.738384 11.383 0.736552 11.3707 0.734737C11.3651 0.733921 11.3596 0.73308 11.354 0.732268C11.3362 0.72969 11.3185 0.727161 11.3007 0.724706C11.2965 0.724114 11.2922 0.723559 11.2879 0.722971C11.2743 0.721117 11.2607 0.719271 11.2472 0.717479C11.2398 0.716512 11.2325 0.715592 11.2252 0.714651C11.2148
        0.713304 11.2044 0.711973 11.194 0.710672C11.1857 0.709629 11.1774 0.708624 11.1691 0.707609C11.1596 0.706454 11.1501 0.705305 11.1406 0.70419C11.132 0.703168 11.1233 0.702166 11.1147 0.701171C11.1056 0.70013 11.0966 0.699107 11.0875 0.6981C11.0785 0.697094 11.0695 0.696095 11.0605 0.695127C11.0515 0.694152 11.0425 0.693208 11.0335 0.692269C11.0248 0.69136 11.0162 0.690444 11.0075 0.689571C10.9976 0.688568 10.9878 0.68761 10.9779 0.68665C10.9698 0.685865 10.9618 0.685045 10.9537 0.684283C10.9369 0.682695 10.92 0.681155 10.9032 0.679677C10.8941 0.678869 10.885 0.678118 10.8758 0.677343C10.8674 0.676632 10.859 0.675903 10.8506 0.675213C10.8406 0.674401 10.8306 0.673624 10.8206 0.672852C10.8129 0.67225 10.8052 0.671653 10.7975 0.671075C10.7877 0.670339 10.7778 0.669626 10.768 0.668924C10.7601 0.668364 10.7522 0.667817 10.7444 0.667276C10.7343 0.666596 10.7243 0.665922 10.7142 0.665275C10.707 0.664812 10.6998 0.664363 10.6926 0.663914C10.6819 0.663259 10.6712 0.662604 10.6605 0.661986C10.6544 0.661632 10.6483 0.661301 10.6422 0.660962C10.6305 0.660318 10.6189 0.659668 10.6072 0.659067C10.6041 0.658915 10.6011 0.658779 10.598 0.658626C10.576 0.657526 10.5539 0.656511 10.5319 0.655595C10.5099 0.654677 10.4878 0.65385 10.4658 0.653116C10.4625 0.653001 10.4592 0.652886 10.4559 0.652775C10.4427 0.652352 10.4295 0.651975 10.4163 0.651617C10.4124 0.651508 10.4084 0.651393 10.4044 0.65129C10.3911 0.650952 10.3778 0.650644 10.3644 0.650362C10.3609 0.65029 10.3574 0.65022 10.3538 0.65015C10.3399 0.649877 10.326 0.64964 10.3121 0.649438C10.3098 0.649404 10.3074 0.649374 10.3051 0.649347C10.29 0.649142 10.2749 0.649
        10.2598 0.648879C10.2544 0.648841 10.249 0.648814 10.2436 0.648775C10.2334 0.648721 10.2232 0.648679 10.213 0.648657C10.2074 0.64865 10.2017 0.648636 10.1961 0.64864C10.1838 0.648638 10.1715 0.64867 10.1592 0.648729C10.1542 0.648757 10.1492 0.648777 10.1442 0.648811C10.1319 0.648892 10.1197 0.649002 10.1075 0.649137C10.1005 0.649212 10.0936 0.649305 10.0867 0.649406C10.0788 0.649509 10.0709 0.649637 10.0629 0.649765C10.0554 0.649893 10.0479 0.650019 10.0404 0.650163C10.0324 0.65032 10.0245 0.650498 10.0165 0.650678C10.0032 0.650975 9.98993 0.651303 9.97666 0.651665C9.96988 0.651853 9.96311 0.65203 9.95632 0.652237C9.94727 0.652506 9.93824 0.652802 9.92917 0.653107C9.92392 0.653278 9.91866 0.653456 9.91341 0.653646C9.90383 0.65398 9.89425 0.654326 9.88466 0.654698C9.88075 0.654849 9.87682 0.65501 9.87291 0.655175C9.8518 0.656021 9.83071 0.656949 9.80963 0.657967C9.80815 0.658033 9.80669 0.6581 9.80523 0.658168C9.79465 0.658681 9.78406 0.659226 9.77348 0.659786C9.76983 0.659974 9.76617 0.660167 9.76252 0.660368C9.75146 0.660964 9.74042 0.661576 9.72937 0.66222L9.72901 0.662241C8.28937 0.745956 6.9002 1.21297 5.66125 1.98617L8.08752 2.44655Z"
          fill="#005800"
        />
        <path
          d="M8.08464 4.77092C7.61106 5.15979 7.17553 5.60925 6.789 6.11087C5.97697 7.16471 5.38119 8.44873 5.10332 9.88464C4.25152 14.2864 6.70826 18.4556 10.5958 19.2245C10.6322 19.228 10.6686 19.2311 10.705 19.234C7.00185 18.3075 4.70043 14.2464 5.52886 9.96538C5.80673 8.52947 6.40255 7.24546 7.21463 6.19164C7.60116 5.69002 8.0367 5.24054 8.51029 4.85169C9.59558 3.96057 10.8806 3.38774 12.2336 3.2348C12.7485 3.17659 13.2733 3.17922 13.8006 3.24828C13.7661 3.23778 13.7315 3.22752 13.6968 3.21757C13.0612 3.10171 12.4271 3.08379 11.8073 3.15393C10.4546 3.30704 9.16975 3.8799 8.08464 4.77092Z"
          fill="#50F84E"
        />
        <path
          d="M17.8624 5.81833C17.2638 5.02025 16.5173 4.35777 15.6549 3.88471C15.069 3.56332 14.4296 3.32934 13.7467 3.19976C13.6436 3.18021 13.5408 3.16312 13.4379 3.14906C13.4351 3.14867 13.4323 3.14826 13.4294 3.14788L13.4296 3.14793C13.5189 3.16946 13.6074 3.19283 13.6951 3.21795C13.7298 3.2279 13.7644 3.23816 13.7989 3.24867C14.2283 3.37959 14.6375 3.55326 15.0234 3.76488C16.1993 4.40973 17.1597 5.40685 17.8236 6.61959C18.1164 7.15435 18.3515 7.73102 18.5221 8.33791C18.6652 8.84719 18.7628 9.37775 18.8108 9.92265C18.8832 10.744 18.8429 11.5979 18.676 12.4607C18.509 13.3237 18.2275 14.1319 17.8536 14.8686C16.4192 17.6944 13.6237 19.4673 10.7033 19.2344C10.6669 19.2315 10.6305 19.2284 10.5941 19.2248C10.5043 19.2161 10.4144 19.2056 10.3245 19.193C10.3492 19.1991 10.3739 19.205 10.3987 19.2107C10.4076 19.2127 10.4165 19.2148 10.4254 19.2168C10.4348 19.2189 10.4441 19.221 10.4534 19.223L10.458 19.224C10.4722 19.2271 10.4864 19.2302 10.5006 19.2332C10.5008 19.2333 10.5011 19.2333 10.5013 19.2334C10.5158 19.2364 10.5303 19.2395 10.5448 19.2424C10.5458 19.2426 10.5468 19.2428 10.5479 19.2431C10.5611 19.2458 10.5744 19.2484 10.5878 19.2511C10.5899 19.2515 10.592 19.2519 10.5941 19.2523C10.6088 19.2552 10.6234 19.2581 10.6381 19.2608L10.6386 19.2609C12.3268 19.5813 14.0061 19.2118 15.4405 18.3345C17.3447 17.1698 18.8175 15.11 19.307 12.5805C19.7966 10.0508 19.197 7.59766 17.8624 5.81833Z"
          fill="#005800"
        />
        <path
          d="M13.3049 8.29769C13.2226 8.27562 13.142 8.26134 13.0641 8.25442C13.5369 8.48723 14.167 9.1449 14.2949 9.71494L14.6235 9.51691C14.4767 8.87434 13.7793 8.42479 13.3049 8.29769ZM11.1053 11.6432C10.003 10.7205 9.16158 9.5399 9.59462 7.92376C10.0726 6.13993 11.9304 5.25284 13.7514 5.63654C13.6864 5.61488 13.6204 5.59506 13.5536 5.57717C11.6649 5.07109 9.67458 5.95635 9.17738 7.81196C8.74433 9.4281 9.58571 10.6087 10.688 11.5314C11.5385 12.2583 12.4269 13.0167 12.2789 13.5687C12.1753 13.9556 11.6905 14.0576 11.1925 13.9733C11.263 13.9989 11.3353 14.0216 11.4088 14.0412C11.9704 14.1917 12.5786 14.1194 12.6962 13.6805C12.8441 13.1285 11.9558 12.3701 11.1053 11.6432ZM7.62249 13.7039L9.32166 12.6593C9.321 12.6575 9.32044 12.6557 9.31989 12.6539L7.26866 13.9149C7.4514 15.2326 8.66696 16.0866 10.3026 16.5249C10.3706 16.5431 10.4387 16.5598 10.5069 16.5748C8.97423 16.095 7.79718 14.9639 7.62249 13.7039Z"
          fill="#003A00"
        />
        <path
          d="M7.62128 13.7038L9.67257 12.4428C9.90969 13.2121 10.5743 13.8178 11.4076 14.0411C11.9693 14.1916 12.5774 14.1193 12.695 13.6804C12.8429 13.1284 11.9546 12.37 11.1041 11.6431C10.0018 10.7204 9.16041 9.53978 9.59346 7.92362C10.0907 6.06804 12.081 5.1828 13.9697 5.68888C15.4881 6.09573 16.4665 7.18477 16.572 8.34645L14.6233 9.52084C14.4785 8.87614 13.779 8.42498 13.3038 8.29763C12.7606 8.15209 12.2916 8.34718 12.1935 8.71297C12.0617 9.20513 12.7225 9.5533 13.6664 10.3266C15.033 11.4484 15.7893 12.7488 15.3652 14.3317C14.8181 16.3735 12.7124 17.1708 10.7187 16.6366C9.08307 16.1983 7.80404 15.0216 7.62128 13.7038Z"
          fill="#286C28"
        />
        <path
          d="M9.67296 12.4473L9.32091 12.6638C9.5592 13.4288 10.1595 13.711 10.9908 13.9338C11.0574 13.9516 11.1247 13.9663 11.1917 13.9777C10.4608 13.7141 9.88926 13.1487 9.67296 12.4473ZM13.6668 10.3311C12.723 9.55777 12.0621 9.20958 12.194 8.71743C12.2771 8.40708 12.6273 8.21967 13.0633 8.25887C13.0013 8.22831 12.942 8.20509 12.8869 8.19034C12.3438 8.0448 11.8748 8.23982 11.7767 8.60563C11.6449 9.09778 12.3058 9.44597 13.2497 10.2193C14.6161 11.3411 15.3725 12.6415 14.9484 14.2243C14.4199 16.1966 12.4374 17.0076 10.5062 16.5791C10.5765 16.6012 10.6474 16.6218 10.7191 16.641C12.7128 17.1752 14.8185 16.378 15.3656 14.3362C15.7897 12.7533 15.0334 11.4529 13.6668 10.3311ZM13.9701 5.69343C13.897 5.67384 13.8239 5.65638 13.7506 5.64099C15.1632 6.11084 16.1419 7.43432 16.2428 8.54492L14.6227 9.52135C14.6231 9.52263 14.6233 9.52399 14.6237 9.52526L16.5724 8.35093C16.4669 7.18923 15.4885 6.10027 13.9701 5.69343Z"
          fill="#50F84E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1500_22716">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function Google() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M24.75 5.51172C24.75 2.75029 22.5114 0.511719 19.75 0.511719H5.75C2.98858 0.511719 0.75 2.75029 0.75 5.51172V19.5117C0.75 22.2731 2.98858 24.5117 5.75 24.5117H19.75C22.5114 24.5117 24.75 22.2731 24.75 19.5117V5.51172Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7504 12.7199C21.7504 12.0681 21.6919 11.4415 21.5833 10.8398H12.9268V14.3952H17.8734C17.6603 15.5441 17.0127 16.5176 16.0393 17.1693V19.4755H19.0097C20.7477 17.8754 21.7504 15.5191 21.7504 12.7199Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9266 21.7028C15.4083 21.7028 17.4888 20.8797 19.0096 19.476L16.0391 17.1698C15.2161 17.7213 14.1632 18.0471 12.9266 18.0471C10.5327 18.0471 8.5064 16.4303 7.78363 14.2578H4.71289V16.6392C6.22528 19.6431 9.33362 21.7028 12.9266 21.7028Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.78371 14.2589C7.59989 13.7074 7.49544 13.1183 7.49544 12.5125C7.49544 11.9067 7.59989 11.3176 7.78371 10.7662V8.38477H4.71297C4.09047 9.6256 3.73535 11.0294 3.73535 12.5125C3.73535 13.9957 4.09047 15.3994 4.71297 16.6403L7.78371 14.2589Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9266 6.97596C14.2761 6.97596 15.4876 7.4397 16.4402 8.35048L19.0764 5.71424C17.4847 4.23109 15.4041 3.32031 12.9266 3.32031C9.33362 3.32031 6.22528 5.38001 4.71289 8.3839L7.78363 10.7653C8.5064 8.59279 10.5327 6.97596 12.9266 6.97596Z"
        fill="#EA4335"
      />
    </SvgIcon>
  )
}

export function Facebook() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <rect
        x="0.25"
        y="0.511719"
        width="24"
        height="24"
        rx="5"
        fill="#0B84EE"
      />
      <path
        d="M13.2446 12.7314H15.4779L15.8286 10.4488H13.2442V9.2013C13.2442 8.25309 13.5521 7.41227 14.4337 7.41227H15.8504V5.42034C15.6015 5.38653 15.0751 5.3125 14.0804 5.3125C12.0033 5.3125 10.7856 6.41608 10.7856 8.93032V10.4488H8.65039V12.7314H10.7856V19.0051C11.2085 19.0691 11.6368 19.1125 12.0764 19.1125C12.4739 19.1125 12.8617 19.0759 13.2446 19.0238V12.7314Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function SwithcCurrency() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <path
        d="M13.6572 10.2475L13.6572 18.0781"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.03613 1.91025L6.03613 9.75"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.64648 5.52344C8.34894 3.93974 7.55777 3.1484 6.0369 1.91385C4.51602 3.1484 3.72485 3.93974 2.4273 5.52344"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0469 14.4746C11.3444 16.0583 12.1356 16.8497 13.6565 18.0842C15.1773 16.8497 15.9685 16.0583 17.2661 14.4746"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function Bin() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.8236 3.5856C1.61699 3.5856 1.41981 3.67012 1.2798 3.81871C1.13979 3.96729 1.06973 4.16638 1.08657 4.36775L1.88762 13.9423C1.89085 14.3513 2.04328 14.7462 2.31818 15.0556C2.60202 15.3749 2.99644 15.5806 3.4258 15.6331C3.45622 15.6368 3.48685 15.6387 3.51751 15.6387H10.4835C10.5149 15.6387 10.5462 15.6367 10.5773 15.6328C11.0058 15.5792 11.399 15.3731 11.6817 15.0538C11.9556 14.7446 12.1073 14.3504 12.1104 13.9423L12.9134 4.3679C12.9303 4.1665 12.8603 3.96737 12.7203 3.81876C12.5802 3.67014 12.383 3.5856 12.1764 3.5856H1.8236ZM5.27453 6.96046C5.68294 6.96046 6.01402 7.28424 6.01402 7.68364V11.5406C6.01402 11.94 5.68294 12.2638 5.27453 12.2638C4.86612 12.2638 4.53505 11.94 4.53505 11.5406V7.68364C4.53505 7.28424 4.86612 6.96046 5.27453 6.96046ZM9.46495 7.68364C9.46495 7.28424 9.13388 6.96046 8.72547 6.96046C8.31706 6.96046 7.98598 7.28424 7.98598 7.68364V11.5406C7.98598 11.94 8.31706 12.2638 8.72547 12.2638C9.13388 12.2638 9.46495 11.94 9.46495 11.5406V7.68364Z"
        fill="currentColor"
      />
      <path
        d="M7.73949 1.08647C7.73949 0.687062 7.40841 0.363281 7 0.363281C6.59159 0.363281 6.26051 0.687062 6.26051 1.08647V1.44429H1.5576C1.14919 1.44429 0.818115 1.76807 0.818115 2.16748C0.818115 2.56688 1.14919 2.89066 1.5576 2.89066H12.4424C12.8508 2.89066 13.1819 2.56688 13.1819 2.16748C13.1819 1.76807 12.8508 1.44429 12.4424 1.44429H7.73949V1.08647Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export function Receipt() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.40863 1.17272C7.39548 0.343467 5.93818 0.343467 4.92503 1.17272C4.90071 1.19263 4.87491 1.21475 4.84159 1.24331L4.84159 1.24331L4.84156 1.24333L4.83544 1.24858C4.80362 1.27586 4.79488 1.28331 4.78743 1.28947C4.42813 1.58635 3.9335 1.65868 3.50424 1.47711C3.49534 1.47334 3.48483 1.4687 3.44653 1.45168L1.6381 0.647934C1.4061 0.544823 1.13769 0.56608 0.924811 0.704423C0.711934 0.842766 0.583496 1.07941 0.583496 1.33329V8.26662L0.583496 8.29963C0.58349 9.39177 0.583486 10.2573 0.640484 10.9549C0.69877 11.6683 0.820378 12.2719 1.10122 12.8231C1.55661 13.7169 2.28327 14.4435 3.17704 14.8989C3.72822 15.1797 4.33184 15.3014 5.04523 15.3596C5.74283 15.4166 6.60829 15.4166 7.70038 15.4166H7.7004H7.70041H7.70042H7.70044H7.70045H7.70046H7.70048H7.7335H13.3335L13.335 15.4166C14.4849 15.4158 15.4168 14.4834 15.4168 13.3333V10.6666L15.4169 10.5689V10.5689C15.4172 10.0451 15.4175 9.64036 15.3231 9.28821C15.0688 8.3392 14.3276 7.59795 13.3786 7.34366C13.188 7.2926 12.9821 7.26925 12.7502 7.25862V1.33329C12.7502 1.07941 12.6217 0.842766 12.4088 0.704423C12.196 0.56608 11.9276 0.544823 11.6956 0.647934L9.88713 1.45168C9.84883 1.4687 9.83832 1.47334 9.82942 1.47711C9.40016 1.65868 8.90553 1.58635 8.54623 1.28947C8.53878 1.28331 8.53004 1.27586 8.49822 1.24858L8.49209 1.24332L8.49205 1.24329C8.45874 1.21474 8.43294 1.19262 8.40863 1.17272ZM13.9168 13.3333C13.9168 13.6555 13.6557 13.9166 13.3335 13.9166C13.0113 13.9166 12.7502 13.6555 12.7502 13.3333V8.76037C12.8634 8.76677 12.9318 8.77686 12.9904 8.79255C13.4217 8.90813 13.7587 9.24507 13.8742 9.67644C13.9104 9.81135 13.9168 9.99836 13.9168 10.6666V13.3333ZM4.66683 5.24996C4.25262 5.24996 3.91683 5.58574 3.91683 5.99996C3.91683 6.41417 4.25262 6.74996 4.66683 6.74996H7.3335C7.74771 6.74996 8.0835 6.41417 8.0835 5.99996C8.0835 5.58574 7.74771 5.24996 7.3335 5.24996H4.66683ZM5.91683 8.66663C5.91683 8.25241 6.25262 7.91663 6.66683 7.91663L8.66683 7.91663C9.08104 7.91663 9.41683 8.25241 9.41683 8.66663C9.41683 9.08084 9.08104 9.41663 8.66683 9.41663L6.66683 9.41663C6.25262 9.41663 5.91683 9.08084 5.91683 8.66663ZM6.66683 10.5833C6.25262 10.5833 5.91683 10.9191 5.91683 11.3333C5.91683 11.7475 6.25262 12.0833 6.66683 12.0833H8.66683C9.08104 12.0833 9.41683 11.7475 9.41683 11.3333C9.41683 10.9191 9.08104 10.5833 8.66683 10.5833H6.66683ZM5.3335 8.66663C5.3335 9.03482 5.03502 9.33329 4.66683 9.33329C4.29864 9.33329 4.00016 9.03482 4.00016 8.66663C4.00016 8.29844 4.29864 7.99996 4.66683 7.99996C5.03502 7.99996 5.3335 8.29844 5.3335 8.66663ZM4.66683 12C5.03502 12 5.3335 11.7015 5.3335 11.3333C5.3335 10.9651 5.03502 10.6666 4.66683 10.6666C4.29864 10.6666 4.00016 10.9651 4.00016 11.3333C4.00016 11.7015 4.29864 12 4.66683 12Z"
        fill="#4D566D"
      />
    </SvgIcon>
  )
}

export function ErrSign() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <mask id="path-1-inside-1_5593_1987" fill="white">
        <path d="M18.2592 9.31988C18.2592 14.1694 14.3278 18.1007 9.47833 18.1007C4.62882 18.1007 0.69751 14.1694 0.69751 9.31988C0.69751 4.47037 4.62882 0.539062 9.47833 0.539062C14.3278 0.539062 18.2592 4.47037 18.2592 9.31988ZM2.54587 9.31988C2.54587 13.1486 5.64964 16.2523 9.47833 16.2523C13.307 16.2523 16.4108 13.1486 16.4108 9.31988C16.4108 5.49119 13.307 2.38743 9.47833 2.38743C5.64964 2.38743 2.54587 5.49119 2.54587 9.31988Z" />
      </mask>
      <path
        d="M18.2592 9.31988C18.2592 14.1694 14.3278 18.1007 9.47833 18.1007C4.62882 18.1007 0.69751 14.1694 0.69751 9.31988C0.69751 4.47037 4.62882 0.539062 9.47833 0.539062C14.3278 0.539062 18.2592 4.47037 18.2592 9.31988ZM2.54587 9.31988C2.54587 13.1486 5.64964 16.2523 9.47833 16.2523C13.307 16.2523 16.4108 13.1486 16.4108 9.31988C16.4108 5.49119 13.307 2.38743 9.47833 2.38743C5.64964 2.38743 2.54587 5.49119 2.54587 9.31988Z"
        fill="#EE5482"
        stroke="#EE5482"
        strokeWidth="2"
        mask="url(#path-1-inside-1_5593_1987)"
      />
      <rect x="8.6001" y="7" width="2" height="8" rx="1" fill="#EE5482" />
      <circle cx="9.6001" cy="5" r="1" fill="#EE5482" />
    </SvgIcon>
  )
}

export function ErrNext() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
    >
      <path
        d="M2 7.71429H19M19 7.71429L14.1429 2M19 7.71429L14.1429 14"
        stroke="#EE5482"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function Okay() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        id="Vector"
        d="M1 7.91779L5.58413 12.5019L15.6692 1.5"
        stroke="#54EBB9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function Pending() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_3556_16465)">
        <path
          d="M0.75 14.25V23.25"
          stroke="#B2C2EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 21.75H15.75C15.75 20.9544 15.4339 20.1913 14.8713 19.6287C14.3087 19.0661 13.5456 18.75 12.75 18.75H9C9 17.9544 8.68393 17.1913 8.12132 16.6287C7.55871 16.0661 6.79565 15.75 6 15.75H0.75"
          stroke="#B2C2EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 18.75H9"
          stroke="#B2C2EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.68405 12.8164C6.89172 11.2969 6.59224 9.56838 6.82718 7.8709C7.06212 6.17341 7.81983 4.59122 8.99507 3.34404C10.1703 2.09687 11.7048 1.24662 13.3853 0.911369C15.0659 0.576123 16.8091 0.772521 18.3729 1.47329C19.9368 2.17406 21.2436 3.34441 22.1119 4.82182C22.9802 6.29922 23.3668 8.01035 23.2182 9.71756C23.0695 11.4248 22.393 13.0433 21.2824 14.3484C20.1719 15.6535 18.6825 16.5804 17.021 17.0004"
          stroke="#B2C2EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 3.75V9.75H18"
          stroke="#B2C2EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3556_16465">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export function DepositOpen() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.92307 2V18M2 9.85185H18"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function SSL() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 36 40"
      fill="none"
    >
      <path
        d="M1.40943 10.0542C1.4278 9.59624 1.76623 9.21824 2.21538 9.12675C8.62187 7.82185 13.9417 5.22641 17.1979 1.89389C17.6335 1.44816 18.3665 1.44815 18.8021 1.89389C22.0583 5.22641 27.3781 7.82185 33.7846 9.12675C34.2338 9.21824 34.5722 9.59624 34.5906 10.0542C34.6087 10.5073 34.6179 10.9629 34.6179 11.421C34.6179 23.7923 27.9168 34.3902 18.403 38.8092C18.1474 38.9279 17.8526 38.9279 17.597 38.8092C8.08316 34.3902 1.38208 23.7923 1.38208 11.421C1.38208 10.9629 1.39125 10.5073 1.40943 10.0542Z"
        fill="#019F66"
        stroke="#019F66"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4564 25.1865C12.4564 24.4584 12.5999 23.7374 12.8783 23.0647C13.1572 22.392 13.5656 21.7808 14.0804 21.2659C14.5951 20.7511 15.2066 20.3427 15.8791 20.064C16.5517 19.7854 17.2726 19.642 18.0009 19.642C18.7291 19.642 19.45 19.7854 20.1226 20.064C20.7951 20.3427 21.4066 20.7511 21.9214 21.2659C22.4361 21.7808 22.8446 22.392 23.1234 23.0647C23.4019 23.7374 23.5453 24.4584 23.5453 25.1865C23.9828 25.1865 24.3374 25.5411 24.3374 25.9785V27.5627C24.3374 28.3948 24.1734 29.2188 23.8551 29.9876C23.5365 30.7564 23.07 31.4549 22.4814 32.0433C21.8931 32.6317 21.1947 33.0984 20.4258 33.4169C19.6569 33.7353 18.8332 33.8992 18.0009 33.8992C17.1686 33.8992 16.3448 33.7353 15.5759 33.4169C14.8071 33.0984 14.1086 32.6317 13.5203 32.0433C12.9317 31.4549 12.4653 30.7564 12.1466 29.9876C11.8283 29.2188 11.6643 28.3948 11.6643 27.5627V25.9785C11.6643 25.5411 12.019 25.1865 12.4564 25.1865ZM21.9612 25.1865C21.9612 24.6664 21.8587 24.1514 21.6599 23.6709L21.6305 23.6023C21.4325 23.1488 21.1513 22.7362 20.8013 22.3861C20.4335 22.0183 19.9969 21.7266 19.5165 21.5276C19.0358 21.3285 18.521 21.2261 18.0009 21.2261C17.4807 21.2261 16.9659 21.3285 16.4852 21.5276C16.0048 21.7266 15.5682 22.0183 15.2004 22.3861C14.8504 22.7362 14.5692 23.1488 14.3712 23.6023L14.3418 23.6709C14.143 24.1514 14.0405 24.6664 14.0405 25.1865H21.9612ZM18.5698 30.1678C18.9104 29.971 19.1396 29.6028 19.1396 29.1812C19.1396 28.5523 18.6298 28.0426 18.001 28.0426C17.3721 28.0426 16.8623 28.5523 16.8623 29.1812C16.8623 29.6024 17.0911 29.9703 17.4311 30.1672V30.8891C17.4311 31.2035 17.686 31.4584 18.0005 31.4584C18.3149 31.4584 18.5698 31.2035 18.5698 30.8891V30.1678Z"
        fill="white"
      />
      <path
        d="M12.5244 16.7724C11.9741 16.7724 11.4811 16.6829 11.0452 16.5041C10.6093 16.3252 10.2591 16.0605 9.99472 15.7099C9.93098 15.623 9.8747 15.5317 9.82587 15.4361C9.56963 14.9341 10.0531 14.4435 10.6168 14.4435H10.8159C11.2262 14.4435 11.5248 14.8105 11.8276 15.0874C11.992 15.2305 12.2064 15.302 12.4708 15.302C12.7423 15.302 12.9567 15.2412 13.1139 15.1196C13.2711 14.9908 13.3497 14.8155 13.3497 14.5937C13.3497 14.4077 13.2854 14.2539 13.1568 14.1322C13.0353 14.0106 12.8817 13.9104 12.6959 13.8317C12.5172 13.753 12.26 13.6636 11.9241 13.5634C11.4382 13.4132 11.0416 13.2629 10.7343 13.1127C10.427 12.9624 10.1626 12.7406 9.94113 12.4473C9.7196 12.1539 9.60884 11.7712 9.60884 11.2989C9.60884 10.5978 9.86252 10.0504 10.3699 9.65692C10.8772 9.25625 11.5382 9.05592 12.3529 9.05592C13.1818 9.05592 13.8499 9.25625 14.3573 9.65692C14.5926 9.83942 14.7772 10.0558 14.911 10.306C15.1793 10.8075 14.6951 11.3097 14.1264 11.3097H13.8369C13.473 11.3097 13.2013 10.9728 12.921 10.7409C12.7566 10.5978 12.5458 10.5262 12.2886 10.5262C12.067 10.5262 11.8884 10.587 11.7526 10.7087C11.6168 10.8231 11.549 10.9913 11.549 11.2131C11.549 11.4563 11.6633 11.6459 11.892 11.7819C12.1206 11.9178 12.4779 12.0645 12.9638 12.2219C13.4498 12.3865 13.8428 12.5439 14.1429 12.6941C14.4502 12.8444 14.7146 13.0626 14.9361 13.3488C15.1576 13.635 15.2684 14.0035 15.2684 14.4542C15.2684 14.8835 15.1576 15.2734 14.9361 15.624C14.7217 15.9746 14.4073 16.2536 13.9929 16.4611C13.5784 16.6686 13.0889 16.7724 12.5244 16.7724Z"
        fill="white"
      />
      <path
        d="M19.119 16.7724C18.5688 16.7724 18.0757 16.6829 17.6398 16.5041C17.2039 16.3252 16.8537 16.0605 16.5893 15.7099C16.5256 15.623 16.4693 15.5317 16.4205 15.4361C16.1642 14.9341 16.6478 14.4435 17.2114 14.4435H17.4105C17.8208 14.4435 18.1194 14.8105 18.4223 15.0874C18.5866 15.2305 18.801 15.302 19.0654 15.302C19.3369 15.302 19.5513 15.2412 19.7085 15.1196C19.8657 14.9908 19.9443 14.8155 19.9443 14.5937C19.9443 14.4077 19.88 14.2539 19.7514 14.1322C19.6299 14.0106 19.4763 13.9104 19.2905 13.8317C19.1118 13.753 18.8546 13.6636 18.5187 13.5634C18.0328 13.4132 17.6362 13.2629 17.3289 13.1127C17.0217 12.9624 16.7573 12.7406 16.5357 12.4473C16.3142 12.1539 16.2035 11.7712 16.2035 11.2989C16.2035 10.5978 16.4571 10.0504 16.9645 9.65692C17.4719 9.25625 18.1329 9.05592 18.9475 9.05592C19.7764 9.05592 20.4446 9.25625 20.9519 9.65692C21.1872 9.83942 21.3718 10.0558 21.5057 10.306C21.7739 10.8075 21.2897 11.3097 20.721 11.3097H20.4315C20.0677 11.3097 19.796 10.9728 19.5156 10.7409C19.3512 10.5978 19.1404 10.5262 18.8832 10.5262C18.6617 10.5262 18.483 10.587 18.3472 10.7087C18.2115 10.8231 18.1436 10.9913 18.1436 11.2131C18.1436 11.4563 18.2579 11.6459 18.4866 11.7819C18.7153 11.9178 19.0725 12.0645 19.5585 12.2219C20.0444 12.3865 20.4374 12.5439 20.7375 12.6941C21.0448 12.8444 21.3092 13.0626 21.5307 13.3488C21.7523 13.635 21.863 14.0035 21.863 14.4542C21.863 14.8835 21.7523 15.2734 21.5307 15.624C21.3164 15.9746 21.0019 16.2536 20.5875 16.4611C20.173 16.6686 19.6835 16.7724 19.119 16.7724Z"
        fill="white"
      />
      <path
        d="M24.8239 15.2806H26.5167C26.9078 15.2806 27.225 15.5977 27.225 15.9889C27.225 16.3801 26.9078 16.6972 26.5167 16.6972H23.991C23.4387 16.6972 22.991 16.2495 22.991 15.6972V10.0797C22.991 9.57355 23.4013 9.16324 23.9075 9.16324C24.4136 9.16324 24.8239 9.57355 24.8239 10.0797V15.2806Z"
        fill="white"
      />
    </SvgIcon>
  )
}

export function Inventory() {
  return (
    <SvgIcon height="1em" width="1em" viewBox="0 0 24 24">
      <path
        d="M10.2501 13.928V23.1741L10.1954 23.1644C9.72479 23.0609 9.28595 22.8365 8.73639 22.5149L8.14459 22.1614L2.94439 19.0413C2.23843 18.6177 1.72961 18.3201 1.34283 17.9446L1.18365 17.7776C0.885074 17.438 0.650528 17.0474 0.491269 16.6253L0.427792 16.4427C0.241648 15.8598 0.250057 15.2238 0.250058 14.2825V9.71806C0.250058 9.036 0.246137 8.51432 0.314511 8.05693L10.2501 13.928ZM21.6846 8.05693C21.7529 8.51433 21.7501 9.03589 21.7501 9.71806V14.2825C21.7501 15.1061 21.7569 15.696 21.6338 16.221L21.5723 16.4427C21.4347 16.8734 21.2205 17.2755 20.9405 17.6292L20.8165 17.7776C20.4124 18.237 19.8627 18.5571 19.0557 19.0413L13.8555 22.1614C13.1096 22.609 12.5793 22.9359 12.0381 23.1028L11.8047 23.1644C11.7867 23.1683 11.7682 23.1704 11.7501 23.1741V13.928L21.6846 8.05693ZM19.0557 4.95927C19.8628 5.44353 20.4124 5.76347 20.8165 6.22295L20.9405 6.37138C21.0091 6.45802 21.0733 6.5478 21.1338 6.63994L11.0001 12.6282L6.74908 10.1165L17.1251 3.80107L19.0557 4.95927ZM10.3956 0.798142C10.8628 0.721826 11.3412 0.734427 11.8047 0.836228L12.0381 0.897751C12.5794 1.06474 13.1096 1.39158 13.8555 1.83916L15.6729 2.929L5.28619 9.25224L0.865292 6.63994C0.961195 6.49394 1.0678 6.35474 1.18365 6.22295L1.34283 6.05595C1.72959 5.6805 2.23845 5.38284 2.94439 4.95927L8.14459 1.83916C8.99709 1.32766 9.56794 0.974124 10.1954 0.836228L10.3956 0.798142Z"
        fill="#4C566D"
      />
    </SvgIcon>
  )
}

export function LiveCasinoCheck() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M2.42871 8.50014C2.42871 6.56929 2.42871 5.60386 2.75502 4.8463C3.15935 3.90764 3.90764 3.15935 4.8463 2.75502C5.60386 2.42871 6.56929 2.42871 8.50014 2.42871C10.431 2.42871 11.3964 2.42871 12.154 2.75502C13.0926 3.15935 13.8409 3.90764 14.2453 4.8463C14.5716 5.60386 14.5716 6.56929 14.5716 8.50014C14.5716 10.431 14.5716 11.3964 14.2453 12.154C13.8409 13.0926 13.0926 13.8409 12.154 14.2453C11.3964 14.5716 10.431 14.5716 8.50014 14.5716C6.56929 14.5716 5.60386 14.5716 4.8463 14.2453C3.90764 13.8409 3.15935 13.0926 2.75502 12.154C2.42871 11.3964 2.42871 10.431 2.42871 8.50014Z"
        fill="#10AECD"
      />
      <path
        d="M5.61621 8.44938L7.38704 10.2202L11.637 5.97021"
        stroke="#F8F7F1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export function LiveCasinoSeat() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M9.82617 8.77832C11.6019 8.77851 13.0419 10.2184 13.042 11.9941C13.0419 13.3158 11.97 14.3873 10.6484 14.3877H5.7168C4.39494 14.3876 3.32338 13.316 3.32324 11.9941C3.32334 10.2183 4.76321 8.77832 6.53906 8.77832H9.82617ZM8.18262 2.61426C9.73124 2.61452 10.9871 3.8703 10.9873 5.41895C10.9873 6.96772 9.73134 8.22337 8.18262 8.22363C6.63367 8.22363 5.37796 6.96788 5.37793 5.41895C5.37811 3.87014 6.63377 2.61426 8.18262 2.61426Z"
        fill="#42E0FF"
      />
    </SvgIcon>
  )
}
